/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */
import { Language } from '@citrite/translate';
export type locale = 'de' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'nl' | 'pt-BR';
export const languages: Language[] = [
  {
    "key": "de",
    "content": {
      "PaymentFieldLabel": "Zahlung einziehen",
      "SelectFieldLabel": "Dropdownmenü",
      "SendSignatureRequest": {
        "addFieldDataPanel": {
          "autofilledToastMessage": "Populated {{numberOfFieldsCompleted}} fields",
          "autofilledToastWarningDescription": "We weren’t able to populate every field. You can still continue to next step",
          "autofilledToastWarningMessage": "Populated {{numberOfFieldsFilled}} out of {{totalNumberOfFields}} fields",
          "editVariableNote": "Once you enter value here, click on Update fields to fill this value in the document",
          "editedField": "Edited",
          "enterFieldValue": "Enter field value",
          "generateDocumentModal": {
            "cancelButtonText": "Cancel",
            "confirmButtonText": "Generate",
            "description": "Are you sure you’re ready to generate this document? Please note that once it’s generated, you won’t be able to make changes to any fields.",
            "title": "Generate document"
          },
          "invalidMailMessage": "Please enter a valid email address",
          "notFilled": "Not filled",
          "pending": "Ausstehend",
          "populatingFields": "Populating fields",
          "signersFieldEdited": "You have edited some fields but they are not updated in the document. Click on 'Update fields' before moving on.",
          "trackFieldsLabel": "Track fields linked with {{variableName}} ({{filledFields}}/{{totalFields}}) filled",
          "updateFields": "Update fields",
          "variableNotPresentAtSource": "Variable not present at source"
        },
        "documentNameError": "Geben Sie einen Dokumentnamen ein",
        "expirationDaysNotificationMessage": "Wählen Sie ein Ablaufdatum",
        "footer": {
          "changeTemplate": "Vorlage ändern",
          "generateDocument": "Generate document",
          "sendForSignatureProgressMessage": "Ihr Dokument wird vorbereitet. Klicken Sie nicht auf Aktualisieren oder Zurück",
          "sendRequest": "Send for Signature",
          "startOver": "Start over"
        },
        "generatingAndMergingDocumentText": "Just setting things up from your template — almost there!",
        "noVariableComponentInfoModal": {
          "cancelButtonText": "Zurückgehen",
          "confirmButtonText": "Trotzdem fortfahren",
          "description": "Wenn Sie mit dem nächsten Schritt fortfahren, ohne diese Variablen auszufüllen, bleiben die abhängigen Felder leer.",
          "subtitle": "Die folgenden Variablen sind derzeit leer:",
          "title": "Haben Sie vergessen, Variablen einzugeben?"
        },
        "populateFields": "Populate fields",
        "rightPanel": {
          "SignerNotePlaceholder": "Hinweis an alle Unterzeichner hinzufügen",
          "days": "Tag(e)",
          "documentName": "Dokumentname",
          "downloadDocument": "Dokument herunterladen",
          "edit": "Bearbeiten",
          "email": "E-Mail",
          "emailPlaceholder": "E-Mail-Adresse des Empfängers eingeben",
          "emptyListMessage": "Wenn Sie mit der Eingabe beginnen, werden hier die passenden Variablenwerte angezeigt",
          "expiration": "Ablaufdatum",
          "expirationDateMessage": "Ablaufdatum: {{expirationDate}}",
          "expirationDaysError": "Geben Sie eine Zahl zwischen 1 und 365 ein",
          "expirationDaysLabel": "Tag(e)",
          "name": "Name",
          "namePlaceholder": "Namen des Empfängers eingeben",
          "noResults": "Keine Ergebnisse für Ihre Suche",
          "recipientEmailPlaceholder": "E-Mail-Adresse des Empfängers eingeben",
          "recipientNamePlaceholder": "Namen des Empfängers eingeben",
          "searching": "Suchen läuft",
          "securityOptions": "Sicherheitsoptionen",
          "sharefileContactsCallErrorMessage": "Aufgrund eines Problems mit ShareFile-Kontakten können keine Variablenwerte abgerufen werden. Suche löschen und erneut versuchen",
          "signerNote": "Hinweis an alle Unterzeichner",
          "storageLocation": "Speicherort für signiertes Dokument"
        },
        "securityOptions": {
          "generateNewPasscode": "Generieren",
          "kbaAlert": "Unterzeichner werden nach 3 fehlgeschlagenen Versuchen vom Dokument ausgeschlossen.",
          "kbaDescription": "Fordern Sie die Empfänger auf, ihre Identität mit einem wissensbasierten Quiz zu verifizieren. Jeder Unterzeichner muss vor der Unterzeichnung des Dokuments die Verifizierung unabhängig von anderen durchführen.",
          "kbaLabel": "Wissensbasierte Authentifizierung",
          "none": "Keine",
          "passcodeAlert": "Sie müssen diesen Passcode jedem Empfänger mitteilen.",
          "passcodeBlankError": "Geben Sie den Passcode ein",
          "passcodeDescription": "Empfänger müssen einen {<fiveDigit>} Passcode eingeben, um auf die Dokumente zugreifen zu können.",
          "passcodeFiveDigit": "fünfstelligen",
          "passcodeLabel": "Passcode",
          "passcodeLengthError": "Der Passcode muss aus 5 Ziffern bestehen",
          "passcodeOnlyDigits": "Der Passcode darf nur Ziffern enthalten.",
          "passcodePlaceholder": "Passcode eingeben oder generieren",
          "save": "Speichern",
          "title": "Sicherheitsoptionen"
        },
        "signatureRequestFailureMessage": "Fehler beim Senden der Signaturanforderung",
        "signatureRequestSuccessNotification": {
          "message": "Sent signature request",
          "viewButton": "View request"
        },
        "tag": "Vorlage",
        "title": "Signaturanforderung",
        "variables": {
          "description": "Für jede Variable einen Wert auswählen, um die Daten im nächsten Schritt automatisch auszufüllen",
          "noVariablesSelectedError": "Wählen Sie alle Variablen aus.",
          "placeholder": "Geben Sie etwas ein, um eine übereinstimmende Variable zu finden",
          "salesforceIntegrationErrorMsg": "Aufgrund eines Salesforce-Integrationsproblems können keine Variablenwerte abgerufen werden. Überprüfen Sie die Integrationseinstellungen",
          "subTitle": "Choose variable",
          "title": "Populate fields"
        },
        "viewRequest": "View request"
      },
      "SignatureFieldLabel": "Signatur",
      "TextFieldLabel": "Text",
      "add": "Hinzufügen",
      "addCheckbox": "Kontrollkästchen hinzufügen",
      "addFilesFromSharefile": "Elemente von ShareFile hinzufügen",
      "addMyself": "Absender als Rolle hinzufügen",
      "addOptionLabel": "Option hinzufügen",
      "addRole": "Weitere Rolle hinzufügen",
      "addSignature": "Signatur hinzufügen",
      "annotator": "Sie (jetzt)",
      "annotatorOptionTooltip": "Felder im Voraus ausfüllen",
      "apply": "Anwenden",
      "assignedToLabel": "Zugewiesen zu",
      "cancel": "Abbrechen",
      "checkbox": "Kontrollkästchen",
      "checkboxGroup": "Kontrollkästchengruppe",
      "checkboxes": "Kontrollkästchen",
      "clear": "Entfernen",
      "close": "Schließen",
      "components": {
        "attachment": "Anlage",
        "editor": {
          "defaultHelpText": "Anlage hier hochladen",
          "fontSizeLabel": "Schriftgröße",
          "helpTextLabel": "Hilfetext hinzufügen"
        }
      },
      "confirm": "Bestätigen",
      "createDocumentTemplateModal": {
        "description": "Create a template to generate PDF documents and send them for e-signature",
        "features": {
          "addFields": "Add fields such as text, date, or signature for signers to fill out",
          "systemFilledData": "Optionally use data from your system to automatically fill the fields"
        },
        "templates": {
          "dynamic": {
            "description": "A reusable template, generated from a PDF or DOCX file. {<lineBreak>} Ideal if the file won’t change often—great for standard forms and contracts."
          },
          "editableWord": {
            "alertMessage": "You'll need to install ShareFile's Word add-in",
            "description": "A reusable template, directly editable in Microsoft Word using ShareFile's Word add-in. {<lineBreak>} Best for templates that need frequent content updates."
          },
          "title": "Select template type"
        },
        "title": "Create document template"
      },
      "createdTemplateSuccess": "Dokumentvorlage erstellt",
      "dashboard": {
        "card": {
          "createdBy": "Erstellt von"
        },
        "createTemplateButton": "Neue Dokumentvorlage",
        "loading": "Laden...",
        "title": "Vorlagen"
      },
      "date": "Datum",
      "dateExample": "Beispiel:",
      "dateFormatLabel": "Format",
      "dateSignedLabel": "Am Datum der Signatur automatisch ausfüllen",
      "dateSignedTooltip": "Ein Empfänger kann das Feld nicht bearbeiten. Es wird an dem Tag, an dem das Dokument signiert wird, automatisch ausgefüllt.",
      "defaultValueLabel": "Standardtext hinzufügen",
      "deleteConfirmationModal": {
        "cancelButton": "Cancel",
        "cancelButtonText": "Weiter bearbeiten",
        "confirmButtonText": "Verwerfen",
        "okButtonText": "Ok"
      },
      "deleteDetails": {
        "deleteConfirmation": {
          "content": "Are you sure you want to delete the {<templateName>} template? The template will be permanently deleted. If this template is shared, users will lose access",
          "title": "Delete template"
        },
        "notification": {
          "successMessage": "Template deleted successfully"
        }
      },
      "description": "Beschreibung",
      "details": {
        "actionItems": {
          "addToMyTemplates": "Zu meinen Vorlagen hinzufügen",
          "delete": "Delete template",
          "download": "Herunterladen",
          "edit": "Bearbeiten",
          "sendAsSignatureRequest": "Als Signaturanforderung senden",
          "share": "Freigeben",
          "useAsDocument": "Als Dokument verwenden"
        },
        "documentTemplate": "Dokumentvorlage",
        "overview": {
          "createdBy": "Erstellt von",
          "cretedOn": "Erstellt am",
          "description": "Beschreibung",
          "doc": "DOC",
          "edit": "Bearbeiten",
          "pdf": "PDF",
          "tabs": {
            "fields": "Felder",
            "overview": "Übersicht"
          }
        },
        "settings": {
          "disabled": "Deaktiviert",
          "enabled": "Aktiviert",
          "kbaRequirement": "KBA-Anforderung",
          "passcode": "Passcode",
          "title": "Einstellungen angewendet"
        },
        "shareTemplateSuccess": "Dokumentvorlage freigegeben",
        "title": "Dokumentvorlage"
      },
      "discardTemplate": {
        "cancelButtonText": "Weiter bearbeiten",
        "confirmButtonText": "Verwerfen",
        "content": "Wenn Sie dies jetzt schließen, verlieren Sie alle Bearbeitungen und müssen erneut beginnen",
        "title": "Vorlage verwerfen"
      },
      "docTemplateListing": {
        "button": "Erstellen",
        "emptyState": {
          "button": "Vorlage erstellen",
          "subtitle": "Vorlagen verwenden, um die Neuerstellung von Dokumenten zu vermeiden",
          "title": "Erste Dokumentvorlage erstellen"
        },
        "noSearchResults": {
          "subtitle": "{<searchTerm>} wurde in keinem Vorlagentitel und keiner Vorlagenbeschreibung gefunden.",
          "title": "Ihre Suche hat keine Vorlagen ergeben"
        }
      },
      "documentThumbnailAltText": "Keine Miniaturansicht verfügbar",
      "documentToSend": "Dokument auswählen",
      "documentView": {
        "documentPageIndex": "Seite {<currentPage>} von {{totalPages}}",
        "pageChangeInputLabel": "Seite wechseln zu",
        "pageDown": "Nächste Seite",
        "pageUp": "Vorherige Seite"
      },
      "draw": "Zeichnen",
      "dropdownInsufficientOptionsError": "Jedes Dropdownmenü muss mindestens 2 Optionen haben",
      "edit": {
        "cancelText": "Cancel",
        "checkedOutInfo": "We can’t rename, move, or delete files while they’re being edited. We also can’t upload files that have the same name.",
        "checkedOutTitle": "This file is being edited",
        "closeText": "Close",
        "edit": "Edit",
        "editDesktopConfirmMessage": "Make sure you're signed in to ShareFile.",
        "editDesktopOpenMessage": " should have opened in Microsoft {{appType}} on your desktop application.",
        "editDesktopTitle": "Create in Microsoft {{appType}}",
        "editDesktopWarning": "If you don't have Microsoft Word, you can still ",
        "editError": "Error occurred while initializing Edit session. Please try again.",
        "editInMicrosoftWord": "Edit in Microsoft Word",
        "editOnline": "Edit online",
        "editOnlineLearnText": "Learn more about editing online.",
        "editOnlineOpenMessage": " should have opened in Microsoft {{appType}} Online in a new tab.",
        "editOnlineText": "edit online.",
        "editOnlineTitle": "Edit Online",
        "editTroubleText": "Having trouble? ",
        "learnMoreText": "Learn more.",
        "signInCheckboxText": "I've signed in to ShareFile",
        "signInMessage": "Before you can open files in Microsoft {{appType}}, you need to sign in to ShareFile. You'll only need to do this once. ",
        "signInPostScriptText": "After you sign in, come back to this page to open the document.",
        "signInSharefileTitle": "Sign in to ShareFile",
        "signInText": "Sign In",
        "tryAgainText": "Try Again"
      },
      "emptyFolder": "Dieser Ordner ist leer",
      "emptyRoleName": "Dieses Feld ist erforderlich",
      "errorMessages": {
        "createDocumentError": "Fehler beim Erstellen des Dokuments",
        "createDocumentTemplateError": "Fehler beim Erstellen der Dokumentvorlage",
        "deleteUploadedFileError": "Fehler beim Löschen der Datei",
        "fetchDataSourcesError": "Fehler beim Abrufen der Datenquelle",
        "fetchEntitiesError": "Fehler beim Abrufen von Entitäten",
        "fetchFileError": "Failed to download file",
        "fetchPdfFileError": "Fehler beim Herunterladen der Datei",
        "fetchSchemaError": "Fehler beim Abrufen des Schemas",
        "fetchThumbnailUrlError": "Fehler beim Abrufen des Thumbnails",
        "generateDocumentError": "Failed to generate document",
        "getDocumentError": "Fehler beim Abrufen des Dokuments",
        "getDocumentTemplateError": "Fehler beim Abrufen der Dokumentvorlage",
        "getTemplatesError": "Fehler beim Abrufen von Vorlagen",
        "saveVariablesError": "Fehler beim Speichern der Variablen",
        "updateDocumentError": "Fehler beim Speichern des Dokuments",
        "updateDocumentTemplateError": "Fehler beim Speichern der Vorlage",
        "uploadFileError": "Fehler beim Hochladen der Datei"
      },
      "extensionSlots": {
        "createNewTemplate": "Neue Dokumentvorlage",
        "dashboardShortcut": "Dokumentvorlage erstellen",
        "templates": "Vorlagen"
      },
      "favorites": "Favoriten",
      "fieldNameLabel": "Feldname",
      "fieldRequired": "Dieses Feld ist erforderlich",
      "fields": "Felder",
      "fieldsAssignedWarningHeader": "Den Rollen zugewiesene Felder",
      "fieldsAssignedWarningMessage": "Alle Felder, die einer oder mehreren Rollen zugewiesen sind, werden entfernt.",
      "fileNotSupportedTooltip": "Das Dateiformat wird nicht unterstützt",
      "footer": {
        "previousButton": "Voriger Schritt"
      },
      "genericError": "Fehler. Bitte versuchen Sie es noch einmal",
      "groupNameLabel": "Gruppenname",
      "groupRule": "Gruppenregel",
      "hasAtleastOneRoleErrorMessage": "Fügen Sie mindestens eine Rolle hinzu, um fortzufahren",
      "header": {
        "stepper": {
          "stepOne": "Vorlage vorbereiten",
          "stepThree": "Überprüfen und speichern",
          "stepTwo": "Felder hinzufügen"
        },
        "title": "Vorlage erstellen"
      },
      "initials": "Initialen",
      "invalidDocgenRequest": "Die Signaturanforderung scheint ungültig zu sein. Bitte überprüfen Sie die URL",
      "invalidEmail": "Ungültige E-Mailadresse",
      "invalidRecipientErrorMessage": "Wir benötigen einen Namen und eine E-Mailadresse für jeden Empfänger",
      "invalidRoleErrorMessage": "Für jede Rolle muss ein Name vergeben werden",
      "label": "Beschriftung",
      "leftNav": {
        "annotateDescription": "Verwenden Sie diese Felder, um Ihren PDF-Dokumenten Beschriftungen, Kontrollkästchen oder andere Arten von Anmerkungen hinzuzufügen.",
        "annotateDocument": "Dokument mit Anmerkungen versehen",
        "senderFields": "Vom Absender ausgefüllte Felder",
        "signerFields": "Vom Unterzeichner ausgefüllte Felder",
        "signerFilled": {
          "addRoles": "Rollen hinzufügen",
          "descriptionNoRoles": "Legen Sie für jede Person, die am Dokumentprozess beteiligt ist, eine Rolle fest (falls zutreffend).\n\nSie können beispielsweise bei einem Schriftsatz Rollen für 'Kunde', 'Anwalt' und 'Zeuge' erstellen.\n\nWenn jemand Ihre Vorlage verwendet, weist er jeder Rolle einfach eine E-Mail-Adresse zu. Dadurch wird sichergestellt, dass jeder die richtige Version des Dokuments erhält, und der Unterzeichnungsprozess wird vereinfacht",
          "descriptionWithRoles": "Fügen Sie Felder hinzu, die von Benutzern ausgefüllt werden müssen, die diese Vorlage erhalten",
          "dropdownDescription": "Sie fügen Felder für die Rolle {{roleName}} hinzu",
          "manageRoles": "Rollen verwalten",
          "role": "Rolle",
          "title": "Unterzeichner ausgefüllt"
        },
        "systemFilled": {
          "addVariables": "Variablen hinzufügen",
          "descriptionNoVariables": "Um Ihrer Vorlage dynamische Daten hinzuzufügen, verwenden Sie Variablen.\n\nAn dieser Stelle wählen Sie die Datenquelle und den Datensatztyp aus. Später, wenn jemand die Vorlage verwendet, wählt er aus, welchen Datensatztyp er verwenden möchte.",
          "descriptionWithVariables": "Verwenden Sie Variablen, um Ihrer Vorlage dynamische Daten hinzuzufügen.",
          "dropdownDescription": "Sie fügen Daten aus jeder Variablen hinzu",
          "manageVariables": "Variablen verwalten",
          "searchData": "Daten durchsuchen",
          "title": "Vom System ausgefüllt",
          "toolTip": "Vom System ausgefüllte Felder",
          "variable": "Variable"
        }
      },
      "maxFileSizeLimitMessage": "The maximum file size supported is 20 MB",
      "multiLineLabel": "Mehrere Zeilen zulassen",
      "name": "Name",
      "noSignerComponentInfoModal": {
        "cancelButtonText": "Zurückgehen",
        "confirmButtonText": "Trotzdem fortfahren",
        "description": "Sie können trotzdem mit dem nächsten Schritt fortfahren oder zurückgehen und Felder zum Ausfüllen hinzufügen.",
        "subtitle": "Diese Rollen haben nichts zu unterschreiben:",
        "title": "Haben Sie Felder vergessen?"
      },
      "optionsLabel": "Optionen",
      "paymentAmountInvalidError": "Geben Sie einen Zahlungsbetrag ein, um fortzufahren",
      "personalFolders": "Persönliche Ordner",
      "preparePage": {
        "footerButton": "Nächster Schritt"
      },
      "previous": "Zurück",
      "radio": "Optionsfeldgruppe",
      "readyState": "Bereit!",
      "reasonDeclineLabel": "Grund für die Ablehnung",
      "reasonVoidLabel": "Grund für Stornierung",
      "recipientListHeading": "Welche Rollen erfordert diese Vorlage?",
      "recipientName": "Name",
      "recipientRemindButtonLabel": "Erinnern",
      "recipientRole": "Rolle",
      "recipientRoleSigner": "Unterzeichner",
      "recipientRoleViewer": "Leseberechtigter",
      "recipientStatusSigned": "Signiert",
      "recipientUniqueEmailErrorMessage": "Die E-Mail-Adresse des Empfängers muss eindeutig sein.",
      "recipientUnlockLabel": "Entsperren",
      "recipientsLabel": "Empfänger",
      "recordType": "Datensatztyp",
      "referenceIdLabel": "Referenz-ID",
      "reminderSent": "Erinnerung gesendet",
      "removeFieldLabel": "Feld entfernen",
      "requiredFieldLabel": "Pflichtfeld",
      "reviewAndSave": "Überprüfen und speichern",
      "reviewPage": {
        "descriptionPlaceholderText": "Beschreibungstext eingeben",
        "footerButton": "Vorlage speichern",
        "kbaRequirement": "KBA-Anforderung",
        "kbaTooltip": "Fordern Sie die Unterzeichner auf, ihre Identität mit einem wissensbasierten Quiz zu verifizieren. Jeder Unterzeichner muss vor der Unterzeichnung des Dokuments die Verifizierung unabhängig von anderen durchführen.",
        "passCodeTooltip": "Empfänger müssen einen fünfstelligen Passcode eingeben, um auf Dokumente zugreifen zu können.",
        "passcodeLabel": "Passcode",
        "securityOptionsLabel": "Sicherheitsoptionen",
        "templateNameBlank": "Geben Sie einen Vorlagennamen ein",
        "templatePlaceholderText": "Vorlagennamen eingeben"
      },
      "roleNameUniqueError": "Der Rollenname muss eindeutig sein",
      "roleNameValidationError": "Rollenname muss alphanumerisch sein",
      "save": "Speichern",
      "selectOneOrMoreLabel": "Wählen Sie mindestens einen",
      "selectOnlyOneLabel": "Nur einen auswählen",
      "selfSignature": "Eigene Signatur",
      "sendAgreement": {
        "assignRequestBody": "Weisen Sie den Benutzer, der die Vereinbarung unterzeichnet hat, allen Kundenanforderungen des Auftrags zu",
        "assignRequestTitle": "Anforderung dem Benutzer zuweisen, der die Vereinbarung unterzeichnet hat",
        "changeTemplate": "Vorlage ändern",
        "document": "Dokument",
        "eSignaturePermissionErrorMessage": "Sie haben keinen Zugriff auf Signaturen. Wenden Sie sich an Ihren Administrator, wenn Sie Zugriff benötigen.",
        "nextTemplate": "Weiter: Vorlage auswählen",
        "selectTemplateTitle": "Vorlage auswählen",
        "selectedAgreementTemplate": "Ausgewählte Vereinbarungsvorlage",
        "selectedClient": "Ausgewählter Kunde",
        "shareRequestBody": "Zugewiesene Anforderung freigeben",
        "shareRequestTitle": "Anforderung freigeben",
        "signatureDescription": "Wenn die Vereinbarung unterzeichnet und abgeschlossen ist",
        "stepsTitle": "Schritte des Workflows 'Vereinbarung senden'",
        "title": "Vereinbarung senden"
      },
      "setSigningOrder": "Signaturreihenfolge festlegen",
      "setToDateOfExecution": "Auf Ausführungsdatum festlegen",
      "shareFileFolder": {
        "selectShareFileFolder": {
          "cancelButtonLabel": "Abbrechen",
          "createFolderLabel": "Ordner erstellen",
          "disabledNodeAdminReason": "Administratorberechtigung wird benötigt, um diesen Ordner auszuwählen",
          "disabledSharedFoldersReason": "Freigegebene Ordner der obersten Ebene können nicht ausgewählt werden",
          "modalTitle": "Speicherort für signiertes Dokument",
          "selectFolderButtonLabel": "Ordner auswählen"
        }
      },
      "sharedFolders": "Freigegebene Ordner",
      "signature": "Signatur",
      "signatureAnnotationMessage": "Klicken und ziehen, um die Signatur im Feld zu zeichnen",
      "signatureAnnotationTextMessage": "Geben Sie Ihre Signatur in das Feld unten ein",
      "signatureRequest": {
        "closeDrawerModalContent": "Wenn Sie diese Anforderung jetzt schließen, verlieren Sie alle Bearbeitungen und müssen erneut beginnen",
        "closeDrawerModalTitle": "Signaturanforderung verwerfen"
      },
      "signatureRequestErrorMessage": "Signaturanforderung fehlgeschlagen",
      "signerDescription": "Sie platzieren Felder für jede Rolle",
      "signers": "Unterzeichner",
      "startPage": {
        "addAnotherRole": "Weitere Rolle hinzufügen",
        "addNewRole": "Neue Rolle hinzufügen",
        "deleteButtonAriaLabel": "Rolle löschen {{roleName}}",
        "dragRoleAriaLabel": "Rolle ziehen {{roleName}}",
        "footerButton": "Nächster Schritt: Felder platzieren",
        "navigateAwayDialog": {
          "continue": "Weiter",
          "dontShowAgain": "Diese Nachricht nicht mehr anzeigen",
          "moveAwaySelections": "Wenn Sie Ihren aktuellen Ordner verlassen, gehen Ihre Auswahlen verloren."
        },
        "roleDescription": "Legen Sie für jede Person, die das Dokument unterzeichnen wird, eine Rolle fest. Wenn eine Person diese Vorlage verwendet, gibt sie für jede Rolle eine E-Mail-Adresse an",
        "roleLabel": "Unterzeichnerrollen",
        "roleName": "Rollenname",
        "sequenceInputAriaLabel": "Sequenz für die Rolle {{roleName}} eingeben",
        "setSignerSequence": "Unterzeichnerreihenfolge festlegen"
      },
      "started_onboarding_agreement_flow": "Onboarding-Vereinbarungsablauf gestartet",
      "templateCreationNotificationMessage": "Vorlage {<templateName>} erstellt",
      "text": "Text",
      "textAlignLabel": "Text ausrichten",
      "type": "Typ",
      "unknown": "Unbekannt",
      "uploadDocumentErrorMessage": "Laden Sie ein Dokument hoch, um mit dem nächsten Schritt fortzufahren",
      "uploadDocxFileModal": {
        "fileTypeErrorNotification": "Only DOCX files are supported",
        "okButtonText": "Create template",
        "title": "Upload DOCX file",
        "uploadTypes": {
          "computer": {
            "browse": "browse",
            "dragFilesHereOr": "Drag files here or"
          },
          "sharefile": "From ShareFile"
        }
      },
      "variableNameValidationError": "Variablenname muss alphanumerisch sein",
      "variables": {
        "addAnotherVariable": "Weitere Variable hinzufügen",
        "addNewVariable": "Neue Variable hinzufügen",
        "dataSource": "Datenquelle",
        "deleteButtonAriaLabel": "Variable {{variableName}} löschen",
        "description": "Nutzen Sie Variablen in Ihrer Vorlage, damit die Informationen automatisch ausgefüllt werden. Datentyp und Datenquelle können Sie selbst auswählen. Bei Verwendung der Vorlage gibt der Absender die abzurufenden Daten vor.",
        "errorMessages": {
          "invalidDataSource": "Für jede Variable wird eine Datenquelle benötigt",
          "invalidName": "Für jede Variable muss ein Name vergeben werden",
          "invalidSourceRecord": "Für jede Variable muss ein Quelldatensatz vergeben werden",
          "uniqueName": "Der Variablenname muss eindeutig sein"
        },
        "fieldsAssignedWarningHeader": "Der Variablen zugewiesene Felder",
        "fieldsAssignedWarningMessage": "Alle Felder, die mindestens einer Variablen zugewiesen sind, werden entfernt.",
        "label": "Variable",
        "missingDatasourceIntegration": {
          "addIntegrationBody": "Gehe zu: Konto > Verbindungen > Neue Verbindung hinzufügen.",
          "addIntegrationHeader": "So fügen Sie eine neue Integration hinzu",
          "message": "Ihr Konto hat derzeit keine Verbindungen zu Drittanbietern.\n"
        },
        "sourceRecord": "Quelldatensatz",
        "variableName": "Variablenname"
      },
      "zoomIn": "Vergrößern",
      "zoomOut": "Verkleinern"
    }
  },
  {
    "key": "en",
    "content": {
      "PaymentFieldLabel": "Collect Payment",
      "SelectFieldLabel": "Dropdown",
      "SendSignatureRequest": {
        "addFieldDataPanel": {
          "autofilledToastMessage": "Populated {{numberOfFieldsCompleted}} fields",
          "autofilledToastWarningDescription": "We weren’t able to populate every field. You can still continue to next step",
          "autofilledToastWarningMessage": "Populated {{numberOfFieldsFilled}} out of {{totalNumberOfFields}} fields",
          "editVariableNote": "Once you enter value here, click on Update fields to fill this value in the document",
          "editedField": "Edited",
          "enterFieldValue": "Enter field value",
          "generateDocumentModal": {
            "cancelButtonText": "Cancel",
            "confirmButtonText": "Generate",
            "description": "Are you sure you’re ready to generate this document? Please note that once it’s generated, you won’t be able to make changes to any fields.",
            "title": "Generate document"
          },
          "invalidMailMessage": "Please enter a valid email address",
          "notFilled": "Not filled",
          "pending": "Pending",
          "populatingFields": "Populating fields",
          "signersFieldEdited": "You have edited some fields but they are not updated in the document. Click on 'Update fields' before moving on.",
          "trackFieldsLabel": "Track fields linked with {{variableName}} ({{filledFields}}/{{totalFields}}) filled",
          "updateFields": "Update fields",
          "variableNotPresentAtSource": "Variable not present at source"
        },
        "documentNameError": "Please enter a document name",
        "expirationDaysNotificationMessage": "Choose an expiration date",
        "footer": {
          "changeTemplate": "Change template",
          "generateDocument": "Generate document",
          "sendForSignatureProgressMessage": "Preparing your document. Please do not click Refresh or Back button",
          "sendRequest": "Send for Signature",
          "startOver": "Start over"
        },
        "generatingAndMergingDocumentText": "Just setting things up from your template — almost there!",
        "noVariableComponentInfoModal": {
          "cancelButtonText": "Go back",
          "confirmButtonText": "Continue anyway",
          "description": "If you proceed to the next step without filling these variables, the dependent fields will remain empty.",
          "subtitle": "The following variables are currently empty:",
          "title": "Did you forget to fill in any variables?"
        },
        "populateFields": "Populate fields",
        "rightPanel": {
          "SignerNotePlaceholder": "Add note to all signers",
          "days": "day(s)",
          "documentName": "Document name",
          "downloadDocument": "Download document",
          "edit": "Edit",
          "email": "Email",
          "emailPlaceholder": "Enter recipient email",
          "emptyListMessage": "As you start typing, matching variable values will appear here",
          "expiration": "Expiration",
          "expirationDateMessage": "Expiration date: {{expirationDate}}",
          "expirationDaysError": "Enter a number between 1 and 365",
          "expirationDaysLabel": "day(s)",
          "name": "Name",
          "namePlaceholder": "Enter recipient name",
          "noResults": "No results found for your search",
          "recipientEmailPlaceholder": "Enter recipient email",
          "recipientNamePlaceholder": "Enter recipient name",
          "searching": "Searching",
          "securityOptions": "Security options",
          "sharefileContactsCallErrorMessage": "Unable to get variable values due to some issue with ShareFile contacts. Clear search and try again",
          "signerNote": "Note to all signers",
          "storageLocation": "Storage location for signed document"
        },
        "securityOptions": {
          "generateNewPasscode": "Generate new",
          "kbaAlert": "Signers will be locked out of the document after 3 failed attempts.",
          "kbaDescription": "Require recipients to verify their identity with a knowledge-based quiz. Each signer will need to independently verify before signing the document.",
          "kbaLabel": "Knowledge based authentication",
          "none": "None",
          "passcodeAlert": "You’ll need to share this passcode with each recipient.",
          "passcodeBlankError": "Please enter passcode",
          "passcodeDescription": "Recipients must enter a {<fiveDigit>} passcode to access the documents.",
          "passcodeFiveDigit": "5-digit",
          "passcodeLabel": "Passcode",
          "passcodeLengthError": "The passcode must have 5 digits",
          "passcodeOnlyDigits": "The passcode can contain digits only.",
          "passcodePlaceholder": "Enter or generate passcode",
          "save": "Save",
          "title": "Security options"
        },
        "signatureRequestFailureMessage": "Failed to send signature request",
        "signatureRequestSuccessNotification": {
          "message": "Sent signature request",
          "viewButton": "View request"
        },
        "tag": "Template",
        "title": "Signature request",
        "variables": {
          "description": "Choose a value for each variable and click on ‘update fields’ to populate the linked fields",
          "noVariablesSelectedError": "Please select all the variables.",
          "placeholder": "Type to find matching variable",
          "salesforceIntegrationErrorMsg": "Unable to get variable values due to a Salesforce integration issue. Please check the integration settings",
          "subTitle": "Choose variable",
          "title": "Populate fields"
        },
        "viewRequest": "View request"
      },
      "SignatureFieldLabel": "Signature",
      "TextFieldLabel": "Text",
      "add": "Add",
      "addCheckbox": "Add checkbox",
      "addFilesFromSharefile": "Add items from ShareFile",
      "addMyself": "Add Sender as role",
      "addOptionLabel": "Add option",
      "addRole": "Add another role",
      "addSignature": "Add Signature",
      "annotator": "You (Now)",
      "annotatorOptionTooltip": "Fill out fields in advance",
      "apply": "Apply",
      "assignedToLabel": "Assigned to",
      "cancel": "Cancel",
      "checkbox": "Checkbox",
      "checkboxGroup": "Checkbox group",
      "checkboxes": "Checkboxes",
      "clear": "Clear",
      "close": "Close",
      "components": {
        "attachment": "Attachment",
        "editor": {
          "defaultHelpText": "Upload your attachment here",
          "fontSizeLabel": "Font size",
          "helpTextLabel": "Add help text"
        }
      },
      "confirm": "Confirm",
      "createDocumentTemplateModal": {
        "description": "Create a template to generate PDF documents and send them for e-signature",
        "features": {
          "addFields": "Add fields such as text, date, or signature for signers to fill out",
          "systemFilledData": "Optionally use data from your system to automatically fill the fields"
        },
        "templates": {
          "dynamic": {
            "description": "A reusable template, generated from a PDF or DOCX file. {<lineBreak>} Ideal if the file won’t change often—great for standard forms and contracts."
          },
          "editableWord": {
            "alertMessage": "You'll need to install ShareFile's Word add-in",
            "description": "A reusable template, directly editable in Microsoft Word using ShareFile's Word add-in. {<lineBreak>} Best for templates that need frequent content updates."
          },
          "title": "Select template type"
        },
        "title": "Create document template"
      },
      "createdTemplateSuccess": "Document template created",
      "dashboard": {
        "card": {
          "createdBy": "Created by"
        },
        "createTemplateButton": "New Document Template",
        "loading": "Loading...",
        "title": "Templates"
      },
      "date": "Date",
      "dateExample": "Example:",
      "dateFormatLabel": "Format",
      "dateSignedLabel": "Auto-fill date signed",
      "dateSignedTooltip": "A recipient will not be able to edit the field. It will be filled in automatically on the day the document is signed.",
      "defaultValueLabel": "Add default text",
      "deleteConfirmationModal": {
        "cancelButton": "Cancel",
        "cancelButtonText": "Continue editing",
        "confirmButtonText": "Discard",
        "okButtonText": "Ok"
      },
      "deleteDetails": {
        "deleteConfirmation": {
          "content": "Are you sure you want to delete the {<templateName>} template? The template will be permanently deleted. If this template is shared, users will lose access",
          "title": "Delete template"
        },
        "notification": {
          "successMessage": "Template deleted successfully"
        }
      },
      "description": "Description",
      "details": {
        "actionItems": {
          "addToMyTemplates": "Add to my templates",
          "delete": "Delete template",
          "download": "Download",
          "edit": "Edit",
          "sendAsSignatureRequest": "Send as signature request",
          "share": "Share",
          "useAsDocument": "Use as a document"
        },
        "documentTemplate": "document template",
        "overview": {
          "createdBy": "Created by",
          "cretedOn": "Created on",
          "description": "Description",
          "doc": "DOC",
          "edit": "Edit",
          "pdf": "PDF",
          "tabs": {
            "fields": "Fields",
            "overview": "Overview"
          }
        },
        "settings": {
          "disabled": "Disabled",
          "enabled": "Enabled",
          "kbaRequirement": "KBA requirement",
          "passcode": "Passcode",
          "title": "Settings applied"
        },
        "shareTemplateSuccess": "Document template shared",
        "title": "Document template"
      },
      "discardTemplate": {
        "cancelButtonText": "Continue editing",
        "confirmButtonText": "Discard",
        "content": "If you close this now, you will lose your progress and you will have to start again",
        "title": "Discard template"
      },
      "docTemplateListing": {
        "button": "Create",
        "emptyState": {
          "button": "Create template",
          "subtitle": "Start using templates to avoid recreating documents",
          "title": "Create first document template"
        },
        "noSearchResults": {
          "subtitle": "We couldn't find {<searchTerm>} in any template titles or descriptions.",
          "title": "Your search doesn’t match any templates"
        }
      },
      "documentThumbnailAltText": "No thumbnail available",
      "documentToSend": "Select document",
      "documentView": {
        "documentPageIndex": "Page {<currentPage>} of {{totalPages}}",
        "pageChangeInputLabel": "Change page to",
        "pageDown": "Next page",
        "pageUp": "Previous page"
      },
      "draw": "Draw",
      "dropdownInsufficientOptionsError": "Each dropdown needs to have at least 2 options",
      "edit": {
        "cancelText": "Cancel",
        "checkedOutInfo": "We can’t rename, move, or delete files while they’re being edited. We also can’t upload files that have the same name.",
        "checkedOutTitle": "This file is being edited",
        "closeText": "Close",
        "edit": "Edit",
        "editDesktopConfirmMessage": "Make sure you're signed in to ShareFile.",
        "editDesktopOpenMessage": " should have opened in Microsoft {{appType}} on your desktop application.",
        "editDesktopTitle": "Create in Microsoft {{appType}}",
        "editDesktopWarning": "If you don't have Microsoft Word, you can still ",
        "editError": "Error occurred while initializing Edit session. Please try again.",
        "editInMicrosoftWord": "Edit in Microsoft Word",
        "editOnline": "Edit online",
        "editOnlineLearnText": "Learn more about editing online.",
        "editOnlineOpenMessage": " should have opened in Microsoft {{appType}} Online in a new tab.",
        "editOnlineText": "edit online.",
        "editOnlineTitle": "Edit Online",
        "editTroubleText": "Having trouble? ",
        "learnMoreText": "Learn more.",
        "signInCheckboxText": "I've signed in to ShareFile",
        "signInMessage": "Before you can open files in Microsoft {{appType}}, you need to sign in to ShareFile. You'll only need to do this once. ",
        "signInPostScriptText": "After you sign in, come back to this page to open the document.",
        "signInSharefileTitle": "Sign in to ShareFile",
        "signInText": "Sign In",
        "tryAgainText": "Try Again"
      },
      "emptyFolder": "This folder is empty",
      "emptyRoleName": "This field is required",
      "errorMessages": {
        "createDocumentError": "Failed to create document",
        "createDocumentTemplateError": "Failed to create document template",
        "deleteUploadedFileError": "Failed to delete file",
        "fetchDataSourcesError": "Failed to fetch Data source",
        "fetchEntitiesError": "Failed to fetch entities",
        "fetchFileError": "Failed to download file",
        "fetchPdfFileError": "Failed to download PDF file",
        "fetchSchemaError": "Failed to fetch schema",
        "fetchThumbnailUrlError": "Failed to fetch thumbnail",
        "generateDocumentError": "Failed to generate document",
        "getDocumentError": "Failed to fetch document",
        "getDocumentTemplateError": "Failed to fetch document template",
        "getTemplatesError": "Failed to fetch templates",
        "saveVariablesError": "Failed to save variable",
        "updateDocumentError": "Failed to save document",
        "updateDocumentTemplateError": "Failed to save template",
        "uploadFileError": "Failed to upload file"
      },
      "extensionSlots": {
        "createNewTemplate": "New Document Template",
        "dashboardShortcut": "Create Document Template",
        "templates": "Templates"
      },
      "favorites": "Favorites",
      "fieldNameLabel": "Field name",
      "fieldRequired": "This field is required",
      "fields": "Fields",
      "fieldsAssignedWarningHeader": "Fields assigned to roles",
      "fieldsAssignedWarningMessage": "All fields assigned to the role(s) will be removed.",
      "fileNotSupportedTooltip": "Unsupported file format",
      "footer": {
        "previousButton": "Previous Step"
      },
      "genericError": "Something went wrong. Please try again",
      "groupNameLabel": "Name group",
      "groupRule": "Group rule",
      "hasAtleastOneRoleErrorMessage": "Add at least one role to proceed",
      "header": {
        "stepper": {
          "stepOne": "Prepare template",
          "stepThree": "Review & save",
          "stepTwo": "Add fields"
        },
        "title": "Create template"
      },
      "initials": "Initials",
      "invalidDocgenRequest": "Signature request seems invalid, please verify the Url",
      "invalidEmail": "Invalid email",
      "invalidRecipientErrorMessage": "We need a name and email for each recipient",
      "invalidRoleErrorMessage": "We need a name for each role",
      "label": "Label",
      "leftNav": {
        "annotateDescription": "Use these fields to add labels, checkboxes, or other types of annotations to your PDF documents.",
        "annotateDocument": "Annotate document",
        "senderFields": "Sender filled Fields",
        "signerFields": "Signer filled Fields",
        "signerFilled": {
          "addRoles": "Add roles",
          "descriptionNoRoles": "Make a role for each person who will participate in the document process. (if applicable)\n\nFor example, on a legal contract, you could create roles for \"Client\", \"Lawyer\" and \"Witness\".\n\nWhen someone uses your template, they'll simply assign email addresses to each role. This ensures everyone gets the right version of the document and streamlines the signing process",
          "descriptionWithRoles": "Add fields that need to be filled by users who receive this template",
          "dropdownDescription": "You'll add fields for {{roleName}} role",
          "manageRoles": "Manage roles",
          "role": "Role",
          "title": "Signer filled"
        },
        "systemFilled": {
          "addVariables": "Add variables",
          "descriptionNoVariables": "To add dynamic data to your template, use variables.\n\nAt this point, you will select the data source and record type. Later on, when someone uses the template, they will choose which record type to use.",
          "descriptionWithVariables": "To add dynamic data to your template, use variables.",
          "dropdownDescription": "You'll add data from each variable",
          "manageVariables": "Manage variables",
          "searchData": "Search data",
          "title": "System filled",
          "toolTip": "System filled Fields",
          "variable": "Variable"
        }
      },
      "maxFileSizeLimitMessage": "The maximum file size supported is 20 MB",
      "multiLineLabel": "Allow multiple lines",
      "name": "Name",
      "noSignerComponentInfoModal": {
        "cancelButtonText": "Go back",
        "confirmButtonText": "Continue anyway",
        "description": "You can continue to the next step anyway, or you can go back and add fields for them to fill out.",
        "subtitle": "These roles don’t have anything to sign:",
        "title": "Did you forget any fields?"
      },
      "optionsLabel": "Options",
      "paymentAmountInvalidError": "Enter a payment amount to continue",
      "personalFolders": "Personal Folders",
      "preparePage": {
        "footerButton": "Next Step"
      },
      "previous": "Previous",
      "radio": "Radio Group",
      "readyState": "Ready!",
      "reasonDeclineLabel": "Decline reason",
      "reasonVoidLabel": "Void reason",
      "recipientListHeading": "What roles does this template need?",
      "recipientName": "Name",
      "recipientRemindButtonLabel": "Remind",
      "recipientRole": "Role",
      "recipientRoleSigner": "Signer",
      "recipientRoleViewer": "Viewer",
      "recipientStatusSigned": "Signed",
      "recipientUniqueEmailErrorMessage": "Recipient email must be unique.",
      "recipientUnlockLabel": "Unlock",
      "recipientsLabel": "Recipients",
      "recordType": "Record type",
      "referenceIdLabel": "Reference ID",
      "reminderSent": "Reminder sent",
      "removeFieldLabel": "Remove Field",
      "requiredFieldLabel": "Required field",
      "reviewAndSave": "Review and Save",
      "reviewPage": {
        "descriptionPlaceholderText": "Enter description text",
        "footerButton": "Save Template",
        "kbaRequirement": "KBA requirement",
        "kbaTooltip": "Require signers to verify their identity with a knowledge-based quiz. Each signer will need to independently verify before signing the document.",
        "passCodeTooltip": "Recipients must enter a 5-digit passcode to access documents.",
        "passcodeLabel": "Passcode",
        "securityOptionsLabel": "Security Options",
        "templateNameBlank": "Enter a template name",
        "templatePlaceholderText": "Enter template name"
      },
      "roleNameUniqueError": "Role name should be unique",
      "roleNameValidationError": "Role name should be alpha numeric",
      "save": "Save",
      "selectOneOrMoreLabel": "Select one or more",
      "selectOnlyOneLabel": "Select only one",
      "selfSignature": "Your signature",
      "sendAgreement": {
        "assignRequestBody": "Assign the user that signed the agreement to all the client requests of the engagement",
        "assignRequestTitle": "Assign the request ot the user that signed the agreement",
        "changeTemplate": "Change template",
        "document": "document",
        "eSignaturePermissionErrorMessage": "You don't have access to signatures. Reach out to your admin if you need access.",
        "nextTemplate": "Next: Select Template",
        "selectTemplateTitle": "Select template",
        "selectedAgreementTemplate": "Selected agreement template",
        "selectedClient": "Selected client",
        "shareRequestBody": "Share the assigned request",
        "shareRequestTitle": "Share the request",
        "signatureDescription": "When the agreement is signed and completed",
        "stepsTitle": "Send Agreement Workflow Steps",
        "title": "Send agreement"
      },
      "setSigningOrder": "Set signing order",
      "setToDateOfExecution": "Set to date of execution",
      "shareFileFolder": {
        "selectShareFileFolder": {
          "cancelButtonLabel": "Cancel",
          "createFolderLabel": "Create folder",
          "disabledNodeAdminReason": "Admin permission is needed to select this folder",
          "disabledSharedFoldersReason": "Cannot select top level shared folders",
          "modalTitle": "Storage location for signed document",
          "selectFolderButtonLabel": "Select folder"
        }
      },
      "sharedFolders": "Shared Folders",
      "signature": "Signature",
      "signatureAnnotationMessage": "Click and drag to draw your signature inside the box",
      "signatureAnnotationTextMessage": "Type your signature in the field below",
      "signatureRequest": {
        "closeDrawerModalContent": "If you close this request now, you will lose your progress and you will have to start again",
        "closeDrawerModalTitle": "Discard signature request"
      },
      "signatureRequestErrorMessage": "Signature request failed",
      "signerDescription": "You’ll place fields for each role",
      "signers": "Signers",
      "startPage": {
        "addAnotherRole": "Add another role",
        "addNewRole": "Add a new role",
        "deleteButtonAriaLabel": "Delete role {{roleName}}",
        "dragRoleAriaLabel": "Drag role {{roleName}}",
        "footerButton": "Next Step: Place Fields",
        "navigateAwayDialog": {
          "continue": "Continue",
          "dontShowAgain": "Don't show this message again",
          "moveAwaySelections": "If you move away from your current folder, your selections will be lost."
        },
        "roleDescription": "Make a role for each person who will be signing the document. Whenever someone uses this template, they’ll provide an email address for each role",
        "roleLabel": "Signer roles",
        "roleName": "Role name",
        "sequenceInputAriaLabel": "Enter sequence for role {{roleName}}",
        "setSignerSequence": "Set signer sequence"
      },
      "started_onboarding_agreement_flow": "Started Onboarding Agreement Flow",
      "templateCreationNotificationMessage": "Created {<templateName>} template",
      "text": "Text",
      "textAlignLabel": "Align text",
      "type": "Type",
      "unknown": "Unknown",
      "uploadDocumentErrorMessage": "Upload a document to move to the next step",
      "uploadDocxFileModal": {
        "fileTypeErrorNotification": "Only DOCX files are supported",
        "okButtonText": "Create template",
        "title": "Upload DOCX file",
        "uploadTypes": {
          "computer": {
            "browse": "browse",
            "dragFilesHereOr": "Drag files here or"
          },
          "sharefile": "From ShareFile"
        }
      },
      "variableNameValidationError": "Variable name should be alpha numeric",
      "variables": {
        "addAnotherVariable": "Add another variable",
        "addNewVariable": "Add a new variable",
        "dataSource": "Data source",
        "deleteButtonAriaLabel": "Delete variable {{variableName}}",
        "description": "Use variables in your template so that information can be filled in automatically. You can select the data type and data source. When using the template, the sender will specify the data to be picked.",
        "errorMessages": {
          "invalidDataSource": "We need a data source for each variable",
          "invalidName": "We need a name for each variable",
          "invalidSourceRecord": "We need a source record for each variable",
          "uniqueName": "Variable name should be unique"
        },
        "fieldsAssignedWarningHeader": "Fields assigned to variable",
        "fieldsAssignedWarningMessage": "All fields assigned to the variable will be removed.",
        "label": "Variable",
        "missingDatasourceIntegration": {
          "addIntegrationBody": "Go to:  account > Connections > add new connection.",
          "addIntegrationHeader": "To add a new integration",
          "message": "Your account doesn’t have any third party connections at moment.\n"
        },
        "sourceRecord": "Source record",
        "variableName": "Variable name"
      },
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out"
    }
  },
  {
    "key": "es",
    "content": {
      "PaymentFieldLabel": "Cobrar pago",
      "SelectFieldLabel": "Menú desplegable",
      "SendSignatureRequest": {
        "addFieldDataPanel": {
          "autofilledToastMessage": "Populated {{numberOfFieldsCompleted}} fields",
          "autofilledToastWarningDescription": "We weren’t able to populate every field. You can still continue to next step",
          "autofilledToastWarningMessage": "Populated {{numberOfFieldsFilled}} out of {{totalNumberOfFields}} fields",
          "editVariableNote": "Once you enter value here, click on Update fields to fill this value in the document",
          "editedField": "Edited",
          "enterFieldValue": "Enter field value",
          "generateDocumentModal": {
            "cancelButtonText": "Cancel",
            "confirmButtonText": "Generate",
            "description": "Are you sure you’re ready to generate this document? Please note that once it’s generated, you won’t be able to make changes to any fields.",
            "title": "Generate document"
          },
          "invalidMailMessage": "Please enter a valid email address",
          "notFilled": "Not filled",
          "pending": "Pendiente",
          "populatingFields": "Populating fields",
          "signersFieldEdited": "You have edited some fields but they are not updated in the document. Click on 'Update fields' before moving on.",
          "trackFieldsLabel": "Track fields linked with {{variableName}} ({{filledFields}}/{{totalFields}}) filled",
          "updateFields": "Update fields",
          "variableNotPresentAtSource": "Variable not present at source"
        },
        "documentNameError": "Introduzca un nombre de documento",
        "expirationDaysNotificationMessage": "Elija una fecha de caducidad",
        "footer": {
          "changeTemplate": "Cambiar plantilla",
          "generateDocument": "Generate document",
          "sendForSignatureProgressMessage": "Preparando el documento. No haga clic en el botón Actualizar o Atrás.",
          "sendRequest": "Send for Signature",
          "startOver": "Start over"
        },
        "generatingAndMergingDocumentText": "Just setting things up from your template — almost there!",
        "noVariableComponentInfoModal": {
          "cancelButtonText": "Volver",
          "confirmButtonText": "Continuar de todos modos",
          "description": "Si continúa con el siguiente paso sin completar estas variables, los campos dependientes permanecerán vacíos.",
          "subtitle": "Estas variables están vacías actualmente:",
          "title": "¿Olvidó completar alguna variable?"
        },
        "populateFields": "Populate fields",
        "rightPanel": {
          "SignerNotePlaceholder": "Agregar nota para todos los firmantes",
          "days": "día(s)",
          "documentName": "Nombre del documento",
          "downloadDocument": "Descargar documento",
          "edit": "Modificar",
          "email": "Correo electrónico",
          "emailPlaceholder": "Introducir correo electrónico del destinatario",
          "emptyListMessage": "Cuando empiece a escribir, los valores de las variables coincidentes aparecerán aquí",
          "expiration": "Caducidad",
          "expirationDateMessage": "Fecha de caducidad: {{expirationDate}}",
          "expirationDaysError": "Escriba un número entre 1 y 365",
          "expirationDaysLabel": "día(s)",
          "name": "Nombre",
          "namePlaceholder": "Introducir nombre del destinatario",
          "noResults": "No se encontraron resultados para su búsqueda",
          "recipientEmailPlaceholder": "Introducir correo electrónico del destinatario",
          "recipientNamePlaceholder": "Introducir nombre del destinatario",
          "searching": "Buscando",
          "securityOptions": "Opciones de seguridad",
          "sharefileContactsCallErrorMessage": "No se pueden obtener los valores de las variables debido a algún problema con los contactos de ShareFile. Borre la búsqueda e inténtelo de nuevo.",
          "signerNote": "Nota para todos los firmantes",
          "storageLocation": "Ubicación de almacenamiento del documento firmado"
        },
        "securityOptions": {
          "generateNewPasscode": "Generar nuevo",
          "kbaAlert": "Los firmantes tendrán bloqueado el acceso al documento después de 3 intentos fallidos.",
          "kbaDescription": "Pida a los destinatarios que verifiquen su identidad con un cuestionario de conocimientos. Cada firmante deberá verificarla de forma independiente antes de firmar el documento. Si hay 3 intentos fallidos, se les bloqueará el acceso.",
          "kbaLabel": "Autenticación basada en conocimientos",
          "none": "Ninguno",
          "passcodeAlert": "Deberá compartir este código de acceso con cada destinatario.",
          "passcodeBlankError": "Introduzca el código de acceso",
          "passcodeDescription": "Los destinatarios deben introducir un código de acceso de {<fiveDigit>} para acceder a los documentos.",
          "passcodeFiveDigit": "5 dígitos",
          "passcodeLabel": "Código de acceso",
          "passcodeLengthError": "El código de acceso debe tener 5 dígitos",
          "passcodeOnlyDigits": "El código de acceso solo puede contener dígitos.",
          "passcodePlaceholder": "Introducir o generar código de acceso",
          "save": "Guardar",
          "title": "Opciones de seguridad"
        },
        "signatureRequestFailureMessage": "Error al enviar la solicitud de firma",
        "signatureRequestSuccessNotification": {
          "message": "Sent signature request",
          "viewButton": "View request"
        },
        "tag": "Plantilla",
        "title": "Solicitud de firma",
        "variables": {
          "description": "Seleccione un valor para cada variable para rellenar automáticamente los datos en el siguiente paso",
          "noVariablesSelectedError": "Seleccione todas las variables.",
          "placeholder": "Escriba para buscar la variable coincidente",
          "salesforceIntegrationErrorMsg": "No se pueden obtener los valores de las variables debido a un problema de integración de Salesforce. Compruebe los parámetros de integración.",
          "subTitle": "Choose variable",
          "title": "Populate fields"
        },
        "viewRequest": "View request"
      },
      "SignatureFieldLabel": "Firma",
      "TextFieldLabel": "Texto",
      "add": "Agregar",
      "addCheckbox": "Agregar casilla de verificación",
      "addFilesFromSharefile": "Agregar elementos desde ShareFile",
      "addMyself": "Agregar Remitente como rol",
      "addOptionLabel": "Agregar opción",
      "addRole": "Agregar otro rol",
      "addSignature": "Agregar firma",
      "annotator": "Usted (ahora)",
      "annotatorOptionTooltip": "Rellene los campos con antelación",
      "apply": "Aplicar",
      "assignedToLabel": "Asignado a",
      "cancel": "Cancelar",
      "checkbox": "Casilla de verificación",
      "checkboxGroup": "Grupo de casillas de verificación",
      "checkboxes": "Casillas de verificación",
      "clear": "Borrar",
      "close": "Cerrar",
      "components": {
        "attachment": "Adjunto",
        "editor": {
          "defaultHelpText": "Cargue su adjunto aquí",
          "fontSizeLabel": "Tamaño de fuente",
          "helpTextLabel": "Agregar texto de ayuda"
        }
      },
      "confirm": "Confirmar",
      "createDocumentTemplateModal": {
        "description": "Create a template to generate PDF documents and send them for e-signature",
        "features": {
          "addFields": "Add fields such as text, date, or signature for signers to fill out",
          "systemFilledData": "Optionally use data from your system to automatically fill the fields"
        },
        "templates": {
          "dynamic": {
            "description": "A reusable template, generated from a PDF or DOCX file. {<lineBreak>} Ideal if the file won’t change often—great for standard forms and contracts."
          },
          "editableWord": {
            "alertMessage": "You'll need to install ShareFile's Word add-in",
            "description": "A reusable template, directly editable in Microsoft Word using ShareFile's Word add-in. {<lineBreak>} Best for templates that need frequent content updates."
          },
          "title": "Select template type"
        },
        "title": "Create document template"
      },
      "createdTemplateSuccess": "Plantilla de documento creada",
      "dashboard": {
        "card": {
          "createdBy": "Creado por"
        },
        "createTemplateButton": "Nueva plantilla de documento",
        "loading": "Cargando...",
        "title": "Plantillas"
      },
      "date": "Fecha",
      "dateExample": "Ejemplo:",
      "dateFormatLabel": "Formato",
      "dateSignedLabel": "Fecha de autorrellenado firmada",
      "dateSignedTooltip": "Un destinatario no podrá modificar el campo. Se rellenará automáticamente el día en que se firme el documento.",
      "defaultValueLabel": "Agregar texto predeterminado",
      "deleteConfirmationModal": {
        "cancelButton": "Cancel",
        "cancelButtonText": "Continuar modificando",
        "confirmButtonText": "Descartar",
        "okButtonText": "Ok"
      },
      "deleteDetails": {
        "deleteConfirmation": {
          "content": "Are you sure you want to delete the {<templateName>} template? The template will be permanently deleted. If this template is shared, users will lose access",
          "title": "Delete template"
        },
        "notification": {
          "successMessage": "Template deleted successfully"
        }
      },
      "description": "Descripción",
      "details": {
        "actionItems": {
          "addToMyTemplates": "Agregar a mis plantillas",
          "delete": "Delete template",
          "download": "Descargar",
          "edit": "Modificar",
          "sendAsSignatureRequest": "Enviar como solicitud de firma",
          "share": "Compartir",
          "useAsDocument": "Usar como documento"
        },
        "documentTemplate": "plantilla de documento",
        "overview": {
          "createdBy": "Creado por",
          "cretedOn": "Creado",
          "description": "Descripción",
          "doc": "DOC",
          "edit": "Modificar",
          "pdf": "PDF",
          "tabs": {
            "fields": "Campos",
            "overview": "Vista general"
          }
        },
        "settings": {
          "disabled": "Inhabilitado",
          "enabled": "Habilitado",
          "kbaRequirement": "Requisito de KBA",
          "passcode": "Código de acceso",
          "title": "Parámetros aplicados"
        },
        "shareTemplateSuccess": "Plantilla de documento compartida",
        "title": "Plantilla de documento"
      },
      "discardTemplate": {
        "cancelButtonText": "Continuar modificando",
        "confirmButtonText": "Descartar",
        "content": "Si cierra esto ahora, perderá el trabajo realizado y tendrá que empezar de nuevo",
        "title": "Descartar plantilla"
      },
      "docTemplateListing": {
        "button": "Crear",
        "emptyState": {
          "button": "Crear plantilla",
          "subtitle": "Empiece a usar plantillas para evitar tener que volver a crear documentos",
          "title": "Crear la primera plantilla de documento"
        },
        "noSearchResults": {
          "subtitle": "No hemos podido encontrar {<searchTerm>} en los títulos o descripciones de las plantillas.",
          "title": "Su búsqueda no coincide con ninguna plantilla"
        }
      },
      "documentThumbnailAltText": "No hay ninguna miniatura disponible",
      "documentToSend": "Seleccionar documento",
      "documentView": {
        "documentPageIndex": "Página {<currentPage>} de {{totalPages}}",
        "pageChangeInputLabel": "Cambiar página a",
        "pageDown": "Página siguiente",
        "pageUp": "Página anterior"
      },
      "draw": "Dibujar",
      "dropdownInsufficientOptionsError": "Cada menú desplegable debe tener al menos 2 opciones",
      "edit": {
        "cancelText": "Cancel",
        "checkedOutInfo": "We can’t rename, move, or delete files while they’re being edited. We also can’t upload files that have the same name.",
        "checkedOutTitle": "This file is being edited",
        "closeText": "Close",
        "edit": "Edit",
        "editDesktopConfirmMessage": "Make sure you're signed in to ShareFile.",
        "editDesktopOpenMessage": " should have opened in Microsoft {{appType}} on your desktop application.",
        "editDesktopTitle": "Create in Microsoft {{appType}}",
        "editDesktopWarning": "If you don't have Microsoft Word, you can still ",
        "editError": "Error occurred while initializing Edit session. Please try again.",
        "editInMicrosoftWord": "Edit in Microsoft Word",
        "editOnline": "Edit online",
        "editOnlineLearnText": "Learn more about editing online.",
        "editOnlineOpenMessage": " should have opened in Microsoft {{appType}} Online in a new tab.",
        "editOnlineText": "edit online.",
        "editOnlineTitle": "Edit Online",
        "editTroubleText": "Having trouble? ",
        "learnMoreText": "Learn more.",
        "signInCheckboxText": "I've signed in to ShareFile",
        "signInMessage": "Before you can open files in Microsoft {{appType}}, you need to sign in to ShareFile. You'll only need to do this once. ",
        "signInPostScriptText": "After you sign in, come back to this page to open the document.",
        "signInSharefileTitle": "Sign in to ShareFile",
        "signInText": "Sign In",
        "tryAgainText": "Try Again"
      },
      "emptyFolder": "Esta carpeta está vacía",
      "emptyRoleName": "Este campo es obligatorio",
      "errorMessages": {
        "createDocumentError": "Error al crear el documento",
        "createDocumentTemplateError": "Error al crear la plantilla de documento",
        "deleteUploadedFileError": "Error al eliminar el archivo",
        "fetchDataSourcesError": "Error al obtener el origen de datos",
        "fetchEntitiesError": "Error al obtener las entidades",
        "fetchFileError": "Failed to download file",
        "fetchPdfFileError": "Error al descargar el archivo PDF",
        "fetchSchemaError": "Error al obtener el esquema",
        "fetchThumbnailUrlError": "Error al obtener la miniatura",
        "generateDocumentError": "Failed to generate document",
        "getDocumentError": "Error al obtener el documento",
        "getDocumentTemplateError": "Error al obtener la plantilla de documento",
        "getTemplatesError": "Error al obtener las plantillas",
        "saveVariablesError": "Error al guardar la variable",
        "updateDocumentError": "Error al guardar el documento",
        "updateDocumentTemplateError": "Error al guardar la plantilla",
        "uploadFileError": "No se pudo cargar el archivo"
      },
      "extensionSlots": {
        "createNewTemplate": "Nueva plantilla de documento",
        "dashboardShortcut": "Crear plantilla de documento",
        "templates": "Plantillas"
      },
      "favorites": "Favoritos",
      "fieldNameLabel": "Nombre del campo",
      "fieldRequired": "Este campo es obligatorio",
      "fields": "Campos",
      "fieldsAssignedWarningHeader": "Campos asignados a roles",
      "fieldsAssignedWarningMessage": "Se eliminarán todos los campos asignados a roles.",
      "fileNotSupportedTooltip": "Formato de archivo no compatible",
      "footer": {
        "previousButton": "Paso anterior"
      },
      "genericError": "Se ha producido un error. Inténtelo de nuevo.",
      "groupNameLabel": "Nombre del grupo",
      "groupRule": "Regla de grupo",
      "hasAtleastOneRoleErrorMessage": "Agregue al menos un rol para continuar",
      "header": {
        "stepper": {
          "stepOne": "Preparar plantilla",
          "stepThree": "Revisar y guardar",
          "stepTwo": "Agregar campos"
        },
        "title": "Crear plantilla"
      },
      "initials": "Iniciales",
      "invalidDocgenRequest": "La solicitud de firma no parece válida; compruebe la URL",
      "invalidEmail": "Correo electrónico no válido",
      "invalidRecipientErrorMessage": "Necesitamos un nombre y un correo electrónico para cada destinatario",
      "invalidRoleErrorMessage": "Necesitamos un nombre para cada rol",
      "label": "Etiqueta",
      "leftNav": {
        "annotateDescription": "Use estos campos para agregar etiquetas, casillas de verificación u otros tipos de anotaciones a sus documentos PDF.",
        "annotateDocument": "Anotar documento",
        "senderFields": "Campos rellenados por el remitente",
        "signerFields": "Campos rellenados por el firmante",
        "signerFilled": {
          "addRoles": "Agregar roles",
          "descriptionNoRoles": "Establezca un rol para cada persona que participará en el proceso de documentación. (si corresponde)\n\nPor ejemplo, en un contrato legal, puede crear roles para \"Cliente\", \"Abogado\" y \"Testigo\".\n\nCuando alguien use su plantilla, simplemente asignará direcciones de correo electrónico a cada rol. Esto garantiza que todos obtengan la versión correcta del documento y agiliza el proceso de firma",
          "descriptionWithRoles": "Agregue los campos que deben completar los usuarios que reciben esta plantilla",
          "dropdownDescription": "Agregará campos para el rol {{roleName}}",
          "manageRoles": "Administrar roles",
          "role": "Rol",
          "title": "Rellenado por firmante"
        },
        "systemFilled": {
          "addVariables": "Agregar variables",
          "descriptionNoVariables": "Para agregar datos dinámicos a la plantilla, use variables.\n\nEn este punto, seleccionará la fuente de datos y el tipo de registro. Más adelante, cuando alguien use la plantilla, elegirá qué tipo de registro usar.",
          "descriptionWithVariables": "Para agregar datos dinámicos a la plantilla, use variables.",
          "dropdownDescription": "Agregará datos de cada variable",
          "manageVariables": "Administrar variables",
          "searchData": "Datos de búsqueda",
          "title": "Rellenado por el sistema",
          "toolTip": "Campos rellenados por el sistema",
          "variable": "Variable"
        }
      },
      "maxFileSizeLimitMessage": "The maximum file size supported is 20 MB",
      "multiLineLabel": "Permitir varias líneas",
      "name": "Nombre",
      "noSignerComponentInfoModal": {
        "cancelButtonText": "Volver",
        "confirmButtonText": "Continuar de todos modos",
        "description": "Puede continuar con el siguiente paso de todos modos, o puede volver atrás y agregar campos para rellenar.",
        "subtitle": "Estos roles no tienen nada que firmar:",
        "title": "¿Olvidó algún campo?"
      },
      "optionsLabel": "Opciones",
      "paymentAmountInvalidError": "Introduzca un importe de pago para continuar",
      "personalFolders": "Carpetas personales",
      "preparePage": {
        "footerButton": "Siguiente paso"
      },
      "previous": "Anterior",
      "radio": "Grupo de botones de opciones",
      "readyState": "Listo.",
      "reasonDeclineLabel": "Motivo del rechazo",
      "reasonVoidLabel": "Motivo de anulación",
      "recipientListHeading": "¿Qué roles necesita esta plantilla?",
      "recipientName": "Nombre",
      "recipientRemindButtonLabel": "Avisar",
      "recipientRole": "Rol",
      "recipientRoleSigner": "Firmante",
      "recipientRoleViewer": "Participante",
      "recipientStatusSigned": "Firmado",
      "recipientUniqueEmailErrorMessage": "El correo electrónico del destinatario debe ser único.",
      "recipientUnlockLabel": "Desbloquear",
      "recipientsLabel": "Destinatarios",
      "recordType": "Tipo de registro",
      "referenceIdLabel": "ID de referencia",
      "reminderSent": "Aviso enviado",
      "removeFieldLabel": "Quitar campo",
      "requiredFieldLabel": "Campo obligatorio",
      "reviewAndSave": "Revisar y enviar",
      "reviewPage": {
        "descriptionPlaceholderText": "Introducir texto de la descripción",
        "footerButton": "Guardar plantilla",
        "kbaRequirement": "Requisito de KBA",
        "kbaTooltip": "Pida a los firmantes que verifiquen su identidad con un cuestionario de conocimientos. Cada firmante deberá verificarla de forma independiente antes de firmar el documento. Si hay 3 intentos fallidos, se les bloqueará el acceso.",
        "passCodeTooltip": "Los destinatarios deben introducir un código de acceso de 5 dígitos para acceder a los documentos.",
        "passcodeLabel": "Código de acceso",
        "securityOptionsLabel": "Opciones de seguridad",
        "templateNameBlank": "Introducir un nombre de plantilla",
        "templatePlaceholderText": "Introducir nombre de plantilla"
      },
      "roleNameUniqueError": "El nombre del rol debe ser único",
      "roleNameValidationError": "El nombre del rol debe ser alfanumérico",
      "save": "Guardar",
      "selectOneOrMoreLabel": "Seleccione una opción o más",
      "selectOnlyOneLabel": "Seleccione solo una opción",
      "selfSignature": "Su firma",
      "sendAgreement": {
        "assignRequestBody": "Asignar el usuario que firmó el contrato a todas las solicitudes de clientes del compromiso",
        "assignRequestTitle": "Asignar la solicitud al usuario que firmó el contrato",
        "changeTemplate": "Cambiar plantilla",
        "document": "documento",
        "eSignaturePermissionErrorMessage": "No tiene acceso a las firmas. Contacte con su administrador si necesita acceso.",
        "nextTemplate": "Siguiente: Seleccionar plantilla",
        "selectTemplateTitle": "Seleccionar plantilla",
        "selectedAgreementTemplate": "Plantilla de contrato seleccionada",
        "selectedClient": "Cliente seleccionado",
        "shareRequestBody": "Compartir la solicitud asignada",
        "shareRequestTitle": "Compartir la solicitud",
        "signatureDescription": "Cuando se firme y se complete el contrato",
        "stepsTitle": "Pasos del flujo de trabajo para enviar contratos",
        "title": "Enviar contrato"
      },
      "setSigningOrder": "Establecer orden de firmas",
      "setToDateOfExecution": "Establecer fecha de ejecución",
      "shareFileFolder": {
        "selectShareFileFolder": {
          "cancelButtonLabel": "Cancelar",
          "createFolderLabel": "Crear carpeta",
          "disabledNodeAdminReason": "Se necesita permiso de administrador para seleccionar esta carpeta",
          "disabledSharedFoldersReason": "No se pueden seleccionar carpetas compartidas de nivel superior",
          "modalTitle": "Ubicación de almacenamiento del documento firmado",
          "selectFolderButtonLabel": "Seleccionar carpeta"
        }
      },
      "sharedFolders": "Carpetas compartidas",
      "signature": "Firma",
      "signatureAnnotationMessage": "Haga clic y arrastre para dibujar su firma dentro del cuadro",
      "signatureAnnotationTextMessage": "Introduzca su firma en el campo que aparece a continuación",
      "signatureRequest": {
        "closeDrawerModalContent": "Si cierra esta solicitud ahora, perderá el trabajo realizado y tendrá que empezar de nuevo",
        "closeDrawerModalTitle": "Descartar solicitud de firma"
      },
      "signatureRequestErrorMessage": "Solicitud de firma fallida",
      "signerDescription": "Deberá colocar campos para cada rol",
      "signers": "Firmantes",
      "startPage": {
        "addAnotherRole": "Agregar otro rol",
        "addNewRole": "Agregar un nuevo rol",
        "deleteButtonAriaLabel": "Eliminar rol {{roleName}}",
        "dragRoleAriaLabel": "Arrastrar rol {{roleName}}",
        "footerButton": "Siguiente paso: colocar campos",
        "navigateAwayDialog": {
          "continue": "Continuar",
          "dontShowAgain": "No mostrar este mensaje de nuevo",
          "moveAwaySelections": "Si sale de la carpeta actual, se perderán sus selecciones."
        },
        "roleDescription": "Establezca un rol para cada persona que firmará el documento. Cada vez que alguien use esta plantilla, proporcionará una dirección de correo electrónico para cada rol.",
        "roleLabel": "Roles de firmantes",
        "roleName": "Nombre del rol",
        "sequenceInputAriaLabel": "Introducir secuencia para el rol {{roleName}}",
        "setSignerSequence": "Establecer secuencia de firmantes"
      },
      "started_onboarding_agreement_flow": "Flujo de contratos de incorporación iniciado",
      "templateCreationNotificationMessage": "Plantilla {<templateName>} creada",
      "text": "Texto",
      "textAlignLabel": "Alinear texto",
      "type": "Tipo",
      "unknown": "Desconocido",
      "uploadDocumentErrorMessage": "Cargue un documento para pasar al siguiente paso",
      "uploadDocxFileModal": {
        "fileTypeErrorNotification": "Only DOCX files are supported",
        "okButtonText": "Create template",
        "title": "Upload DOCX file",
        "uploadTypes": {
          "computer": {
            "browse": "browse",
            "dragFilesHereOr": "Drag files here or"
          },
          "sharefile": "From ShareFile"
        }
      },
      "variableNameValidationError": "El nombre de la variable debe ser alfanumérico",
      "variables": {
        "addAnotherVariable": "Agregar otra variable",
        "addNewVariable": "Agregar una nueva variable",
        "dataSource": "Fuente de datos",
        "deleteButtonAriaLabel": "Eliminar variable {{variableName}}",
        "description": "Use variables en la plantilla para que la información se pueda rellenar automáticamente. Puede seleccionar el tipo y la fuente de datos. Al usar la plantilla, el remitente especificará los datos que se van a seleccionar.",
        "errorMessages": {
          "invalidDataSource": "Necesitamos una fuente de datos para cada variable",
          "invalidName": "Necesitamos un nombre para cada variable",
          "invalidSourceRecord": "Necesitamos un registro de origen para cada variable",
          "uniqueName": "El nombre de la variable debe ser único"
        },
        "fieldsAssignedWarningHeader": "Campos asignados a variable",
        "fieldsAssignedWarningMessage": "Se eliminarán todos los campos asignados a la variable.",
        "label": "Variable",
        "missingDatasourceIntegration": {
          "addIntegrationBody": "Vaya a: cuenta > Conexiones > agregar conexión.",
          "addIntegrationHeader": "Para agregar una nueva integración",
          "message": "Su cuenta no tiene ninguna conexión con terceros en este momento.\n"
        },
        "sourceRecord": "Registro de origen",
        "variableName": "Nombre de la variable"
      },
      "zoomIn": "Zoom para acercar",
      "zoomOut": "Zoom para alejar"
    }
  },
  {
    "key": "fr",
    "content": {
      "PaymentFieldLabel": "Recevoir un paiement",
      "SelectFieldLabel": "Liste déroulante",
      "SendSignatureRequest": {
        "addFieldDataPanel": {
          "autofilledToastMessage": "Populated {{numberOfFieldsCompleted}} fields",
          "autofilledToastWarningDescription": "We weren’t able to populate every field. You can still continue to next step",
          "autofilledToastWarningMessage": "Populated {{numberOfFieldsFilled}} out of {{totalNumberOfFields}} fields",
          "editVariableNote": "Once you enter value here, click on Update fields to fill this value in the document",
          "editedField": "Edited",
          "enterFieldValue": "Enter field value",
          "generateDocumentModal": {
            "cancelButtonText": "Cancel",
            "confirmButtonText": "Generate",
            "description": "Are you sure you’re ready to generate this document? Please note that once it’s generated, you won’t be able to make changes to any fields.",
            "title": "Generate document"
          },
          "invalidMailMessage": "Please enter a valid email address",
          "notFilled": "Not filled",
          "pending": "En attente",
          "populatingFields": "Populating fields",
          "signersFieldEdited": "You have edited some fields but they are not updated in the document. Click on 'Update fields' before moving on.",
          "trackFieldsLabel": "Track fields linked with {{variableName}} ({{filledFields}}/{{totalFields}}) filled",
          "updateFields": "Update fields",
          "variableNotPresentAtSource": "Variable not present at source"
        },
        "documentNameError": "Entrez un nom de document",
        "expirationDaysNotificationMessage": "Choisissez une date d'expiration",
        "footer": {
          "changeTemplate": "Modifier le modèle",
          "generateDocument": "Generate document",
          "sendForSignatureProgressMessage": "Votre document est en cours de préparation. Ne cliquez pas sur le bouton Actualiser ou Précédent",
          "sendRequest": "Send for Signature",
          "startOver": "Start over"
        },
        "generatingAndMergingDocumentText": "Just setting things up from your template — almost there!",
        "noVariableComponentInfoModal": {
          "cancelButtonText": "Retour",
          "confirmButtonText": "Continuer quand même",
          "description": "Si vous passez à l'étape suivante sans spécifier la valeur de ces variables, les champs dépendants resteront vides.",
          "subtitle": "Les variables suivantes sont actuellement vides :",
          "title": "Avez-vous oublié de spécifier des variables ?"
        },
        "populateFields": "Populate fields",
        "rightPanel": {
          "SignerNotePlaceholder": "Ajouter une note à tous les signataires",
          "days": "jour(s)",
          "documentName": "Nom du document",
          "downloadDocument": "Télécharger document",
          "edit": "Modifier",
          "email": "E-mail",
          "emailPlaceholder": "Saisir l'adresse e-mail du destinataire",
          "emptyListMessage": "Dès que vous commencerez à taper, les valeurs des variables correspondantes apparaîtront ici",
          "expiration": "Expiration",
          "expirationDateMessage": "Date d'expiration : {{expirationDate}}",
          "expirationDaysError": "Entrez un nombre compris entre 1 et 365",
          "expirationDaysLabel": "jour(s)",
          "name": "Nom",
          "namePlaceholder": "Saisir le nom du destinataire",
          "noResults": "Aucun résultat n'a été trouvé pour votre recherche",
          "recipientEmailPlaceholder": "Saisir l'adresse e-mail du destinataire",
          "recipientNamePlaceholder": "Saisir le nom du destinataire",
          "searching": "Recherche en cours",
          "securityOptions": "Options de sécurité",
          "sharefileContactsCallErrorMessage": "Impossible d'obtenir les valeurs des variables en raison d'un problème avec les contacts ShareFile. Effacez la recherche et réessayez",
          "signerNote": "Notre à tous les signataires",
          "storageLocation": "Emplacement de stockage des documents signés"
        },
        "securityOptions": {
          "generateNewPasscode": "Générer nouveau",
          "kbaAlert": "Après 3 tentatives infructueuses, l'accès des signataires au document sera bloqué.",
          "kbaDescription": "Avant de signer un document, les destinataires devront valider leur identité en s'authentifiant individuellement au moyen d'un quiz basé sur les connaissances.",
          "kbaLabel": "Authentification basée sur les connaissances",
          "none": "Aucune",
          "passcodeAlert": "Vous devrez partager ce code secret avec chaque destinataire.",
          "passcodeBlankError": "Entrez un code secret",
          "passcodeDescription": "Pour accéder aux documents, les destinataires doivent saisir un code secret à <fiveDigit>.",
          "passcodeFiveDigit": "5 chiffres",
          "passcodeLabel": "Code secret",
          "passcodeLengthError": "Le code secret doit avoir 5 chiffres",
          "passcodeOnlyDigits": "Le code secret ne peut contenir que des chiffres.",
          "passcodePlaceholder": "Entrez ou générez un code secret",
          "save": "Enregistrer",
          "title": "Options de sécurité"
        },
        "signatureRequestFailureMessage": "Impossible d'envoyer la demande de signature",
        "signatureRequestSuccessNotification": {
          "message": "Sent signature request",
          "viewButton": "View request"
        },
        "tag": "Modèle",
        "title": "Demande de signature",
        "variables": {
          "description": "Sélectionnez une valeur pour chaque variable afin de permettre le remplissage automatique des données à l'étape suivante",
          "noVariablesSelectedError": "Sélectionnez toutes les variables.",
          "placeholder": "Tapez pour trouver la variable correspondante",
          "salesforceIntegrationErrorMsg": "Impossible d'obtenir les valeurs des variables en raison d'un problème d'intégration Salesforce. Vérifiez les paramètres d'intégration",
          "subTitle": "Choose variable",
          "title": "Populate fields"
        },
        "viewRequest": "View request"
      },
      "SignatureFieldLabel": "Signature",
      "TextFieldLabel": "Texte",
      "add": "Ajouter",
      "addCheckbox": "Ajouter case à cocher",
      "addFilesFromSharefile": "Ajouter des éléments depuis ShareFile",
      "addMyself": "Ajouter l'expéditeur en tant que rôle",
      "addOptionLabel": "Ajouter une option",
      "addRole": "Ajouter un autre rôle",
      "addSignature": "Ajouter une signature",
      "annotator": "Vous (maintenant)",
      "annotatorOptionTooltip": "Remplissez les champs à l'avance",
      "apply": "Appliquer",
      "assignedToLabel": "Attribué à",
      "cancel": "Annuler",
      "checkbox": "Case à cocher",
      "checkboxGroup": "Groupe de cases à cocher",
      "checkboxes": "Cases à cocher",
      "clear": "Effacer",
      "close": "Fermer",
      "components": {
        "attachment": "Pièce jointe",
        "editor": {
          "defaultHelpText": "Chargez votre pièce jointe ici",
          "fontSizeLabel": "Taille de police",
          "helpTextLabel": "Ajouter texte d'aide"
        }
      },
      "confirm": "Confirmer",
      "createDocumentTemplateModal": {
        "description": "Create a template to generate PDF documents and send them for e-signature",
        "features": {
          "addFields": "Add fields such as text, date, or signature for signers to fill out",
          "systemFilledData": "Optionally use data from your system to automatically fill the fields"
        },
        "templates": {
          "dynamic": {
            "description": "A reusable template, generated from a PDF or DOCX file. {<lineBreak>} Ideal if the file won’t change often—great for standard forms and contracts."
          },
          "editableWord": {
            "alertMessage": "You'll need to install ShareFile's Word add-in",
            "description": "A reusable template, directly editable in Microsoft Word using ShareFile's Word add-in. {<lineBreak>} Best for templates that need frequent content updates."
          },
          "title": "Select template type"
        },
        "title": "Create document template"
      },
      "createdTemplateSuccess": "Modèle de document créé",
      "dashboard": {
        "card": {
          "createdBy": "Créé par"
        },
        "createTemplateButton": "Nouveau modèle de document",
        "loading": "Chargement...",
        "title": "Modèles"
      },
      "date": "Date",
      "dateExample": "Exemple :",
      "dateFormatLabel": "Format",
      "dateSignedLabel": "Remplir automatiquement la date de signature",
      "dateSignedTooltip": "Le destinataire ne pourra pas modifier le champ. Il sera rempli automatiquement le jour de la signature du document.",
      "defaultValueLabel": "Ajouter texte par défaut",
      "deleteConfirmationModal": {
        "cancelButton": "Cancel",
        "cancelButtonText": "Continuer la modification",
        "confirmButtonText": "Abandonner",
        "okButtonText": "Ok"
      },
      "deleteDetails": {
        "deleteConfirmation": {
          "content": "Are you sure you want to delete the {<templateName>} template? The template will be permanently deleted. If this template is shared, users will lose access",
          "title": "Delete template"
        },
        "notification": {
          "successMessage": "Template deleted successfully"
        }
      },
      "description": "Description",
      "details": {
        "actionItems": {
          "addToMyTemplates": "Ajouter à mes modèles",
          "delete": "Delete template",
          "download": "Télécharger",
          "edit": "Modifier",
          "sendAsSignatureRequest": "Envoyer en tant que demande de signature",
          "share": "Partager",
          "useAsDocument": "Utiliser comme document"
        },
        "documentTemplate": "modèle de document",
        "overview": {
          "createdBy": "Créé par",
          "cretedOn": "Créé le",
          "description": "Description",
          "doc": "DOC",
          "edit": "Modifier",
          "pdf": "PDF",
          "tabs": {
            "fields": "Champs",
            "overview": "Aperçu"
          }
        },
        "settings": {
          "disabled": "Désactivé",
          "enabled": "Activé",
          "kbaRequirement": "Exigence KBA",
          "passcode": "Code d'accès",
          "title": "Paramètres appliqués"
        },
        "shareTemplateSuccess": "Modèle de document partagé",
        "title": "Modèle de document"
      },
      "discardTemplate": {
        "cancelButtonText": "Continuer la modification",
        "confirmButtonText": "Abandonner",
        "content": "Si vous fermez cette fenêtre maintenant, vous perdrez votre progression et devrez recommencer",
        "title": "Abandonner le modèle"
      },
      "docTemplateListing": {
        "button": "Créer",
        "emptyState": {
          "button": "Création de modèle",
          "subtitle": "Commencez à utiliser des modèles pour ne plus avoir à recréer de documents",
          "title": "Créer un modèle de document initial"
        },
        "noSearchResults": {
          "subtitle": "Nous n'avons pas pu trouver le terme <searchTerm> dans aucun titre ou description de modèle.",
          "title": "Votre recherche ne correspond à aucun modèle"
        }
      },
      "documentThumbnailAltText": "Aucune miniature disponible",
      "documentToSend": "Sélectionner un document",
      "documentView": {
        "documentPageIndex": "Page {<currentPage>} sur {{totalPages}}",
        "pageChangeInputLabel": "Changer page sur",
        "pageDown": "Page suivante",
        "pageUp": "Page précédente"
      },
      "draw": "Dessiner",
      "dropdownInsufficientOptionsError": "Chaque menu déroulant doit avoir au moins 2 options",
      "edit": {
        "cancelText": "Cancel",
        "checkedOutInfo": "We can’t rename, move, or delete files while they’re being edited. We also can’t upload files that have the same name.",
        "checkedOutTitle": "This file is being edited",
        "closeText": "Close",
        "edit": "Edit",
        "editDesktopConfirmMessage": "Make sure you're signed in to ShareFile.",
        "editDesktopOpenMessage": " should have opened in Microsoft {{appType}} on your desktop application.",
        "editDesktopTitle": "Create in Microsoft {{appType}}",
        "editDesktopWarning": "If you don't have Microsoft Word, you can still ",
        "editError": "Error occurred while initializing Edit session. Please try again.",
        "editInMicrosoftWord": "Edit in Microsoft Word",
        "editOnline": "Edit online",
        "editOnlineLearnText": "Learn more about editing online.",
        "editOnlineOpenMessage": " should have opened in Microsoft {{appType}} Online in a new tab.",
        "editOnlineText": "edit online.",
        "editOnlineTitle": "Edit Online",
        "editTroubleText": "Having trouble? ",
        "learnMoreText": "Learn more.",
        "signInCheckboxText": "I've signed in to ShareFile",
        "signInMessage": "Before you can open files in Microsoft {{appType}}, you need to sign in to ShareFile. You'll only need to do this once. ",
        "signInPostScriptText": "After you sign in, come back to this page to open the document.",
        "signInSharefileTitle": "Sign in to ShareFile",
        "signInText": "Sign In",
        "tryAgainText": "Try Again"
      },
      "emptyFolder": "Ce dossier est vide",
      "emptyRoleName": "Ce champ est obligatoire",
      "errorMessages": {
        "createDocumentError": "Impossible de créer le document",
        "createDocumentTemplateError": "Impossible de créer un modèle de document",
        "deleteUploadedFileError": "Impossible de supprimer le fichier",
        "fetchDataSourcesError": "Impossible de récupérer la source de données",
        "fetchEntitiesError": "Impossible de récupérer les entités",
        "fetchFileError": "Failed to download file",
        "fetchPdfFileError": "Impossible de télécharger le fichier PDF",
        "fetchSchemaError": "Impossible de récupérer le schéma",
        "fetchThumbnailUrlError": "Impossible de récupérer la miniature",
        "generateDocumentError": "Failed to generate document",
        "getDocumentError": "Impossible de récupérer le document",
        "getDocumentTemplateError": "Impossible de récupérer le modèle de document",
        "getTemplatesError": "Impossible de récupérer les modèles",
        "saveVariablesError": "Impossible d'enregistrer la variable",
        "updateDocumentError": "Impossible d'enregistrer le document",
        "updateDocumentTemplateError": "Impossible d'enregistrer le modèle",
        "uploadFileError": "Impossible de charger le fichier"
      },
      "extensionSlots": {
        "createNewTemplate": "Nouveau modèle de document",
        "dashboardShortcut": "Créer un modèle de document",
        "templates": "Modèles"
      },
      "favorites": "Favoris",
      "fieldNameLabel": "Nom du champ",
      "fieldRequired": "Ce champ est obligatoire",
      "fields": "Champs",
      "fieldsAssignedWarningHeader": "Champs attribués à des rôles",
      "fieldsAssignedWarningMessage": "Tous les champs attribués aux rôles seront supprimés.",
      "fileNotSupportedTooltip": "Format de fichier non pris en charge",
      "footer": {
        "previousButton": "Étape précédente"
      },
      "genericError": "Une erreur s\\'est produite, veuillez réessayer.",
      "groupNameLabel": "Nommer le groupe",
      "groupRule": "Règle du groupe",
      "hasAtleastOneRoleErrorMessage": "Ajouter au moins un rôle pour continuer",
      "header": {
        "stepper": {
          "stepOne": "Préparez le modèle",
          "stepThree": "Vérifiez & enregistrez",
          "stepTwo": "Ajoutez des champs"
        },
        "title": "Création de modèle"
      },
      "initials": "Initiales",
      "invalidDocgenRequest": "La demande de signature ne semble pas valide. Vérifiez l'URL.",
      "invalidEmail": "Adresse e-mail non valide",
      "invalidRecipientErrorMessage": "Chaque destinataire doit avoir un nom et une adresse e-mail",
      "invalidRoleErrorMessage": "Spécifier un nom pour chaque rôle",
      "label": "Étiquette",
      "leftNav": {
        "annotateDescription": "Utilisez ces champs pour ajouter des étiquettes, des cases à cocher ou d'autres types d'annotations à vos documents PDF.",
        "annotateDocument": "Annoter un document",
        "senderFields": "Champs remplis par l'expéditeur",
        "signerFields": "Champs remplis par le signataire",
        "signerFilled": {
          "addRoles": "Ajouter des rôles",
          "descriptionNoRoles": "Créez un rôle pour chaque personne qui interviendra dans le processus du document (le cas échéant).\n\nPar exemple, dans le cas d'un contrat légal, vous pourriez créer les rôles \"Client\", \"Avocat\" et \"Témoin\".\n\nLorsqu'une personne utilisera votre modèle, il lui suffira simplement d'affecter des adresses e-mail à chaque rôle. Cela permet de s'assurer que tout le monde obtient la bonne version du document et de rationaliser le processus de signature.",
          "descriptionWithRoles": "Ajoutez les champs que doivent remplir les utilisateurs qui reçoivent ce modèle",
          "dropdownDescription": "Vous allez ajouter des champs pour le rôle {{roleName}}",
          "manageRoles": "Gérer les rôles",
          "role": "Rôle",
          "title": "Rempli par le signataire"
        },
        "systemFilled": {
          "addVariables": "Ajouter des variables",
          "descriptionNoVariables": "Pour ajouter des données dynamiques à votre modèle, utilisez des variables.\n\nÀ ce stade, vous allez sélectionner la source de données et le type d'enregistrement. Plus tard, la personne qui utilisera le modèle choisira le type d'enregistrement à utiliser.",
          "descriptionWithVariables": "Pour ajouter des données dynamiques à votre modèle, utilisez des variables.",
          "dropdownDescription": "Vous allez ajouter des données à partir de chaque variable",
          "manageVariables": "Gérer les variables",
          "searchData": "Rechercher des données",
          "title": "Rempli par le système",
          "toolTip": "Champs remplis par le système",
          "variable": "Variable"
        }
      },
      "maxFileSizeLimitMessage": "The maximum file size supported is 20 MB",
      "multiLineLabel": "Autoriser plusieurs lignes",
      "name": "Nom",
      "noSignerComponentInfoModal": {
        "cancelButtonText": "Retour",
        "confirmButtonText": "Continuer quand même",
        "description": "Vous pouvez quand même passer à l'étape suivante ou revenir en arrière et ajouter des champs à remplir.",
        "subtitle": "Ces rôles n'ont rien à signer :",
        "title": "Avez-vous oublié des champs ?"
      },
      "optionsLabel": "Options",
      "paymentAmountInvalidError": "Entrez un montant de paiement pour continuer",
      "personalFolders": "Dossiers personnels",
      "preparePage": {
        "footerButton": "Étape suivante"
      },
      "previous": "Précédent",
      "radio": "Groupe de cases d’option",
      "readyState": "Prêt",
      "reasonDeclineLabel": "Raison du refus",
      "reasonVoidLabel": "Raison d'annulation",
      "recipientListHeading": "De quels rôles ce modèle a-t-il besoin ?",
      "recipientName": "Nom",
      "recipientRemindButtonLabel": "Rappel",
      "recipientRole": "Rôle",
      "recipientRoleSigner": "Signataire",
      "recipientRoleViewer": "Lecteur",
      "recipientStatusSigned": "Signé",
      "recipientUniqueEmailErrorMessage": "L'adresse e-mail du destinataire doit être unique.",
      "recipientUnlockLabel": "Déverrouiller",
      "recipientsLabel": "Destinataires",
      "recordType": "Type d'enregistrement",
      "referenceIdLabel": "ID de référence",
      "reminderSent": "Rappel envoyé",
      "removeFieldLabel": "Supprimer le champ",
      "requiredFieldLabel": "Champ obligatoire",
      "reviewAndSave": "Vérifier et envoyer",
      "reviewPage": {
        "descriptionPlaceholderText": "Entrez le texte de description",
        "footerButton": "Enregistrer le modèle",
        "kbaRequirement": "Exigence KBA",
        "kbaTooltip": "Avant de signer un document, le signataire devra valider son identité en s'authentifiant individuellement au moyen d'un quiz basé sur les connaissances.",
        "passCodeTooltip": "Pour accéder aux documents, les destinataires doivent saisir un code secret à 5 chiffres.",
        "passcodeLabel": "Code d'accès",
        "securityOptionsLabel": "Options de sécurité",
        "templateNameBlank": "Entrez un nom de modèle",
        "templatePlaceholderText": "Entrez un nom de modèle"
      },
      "roleNameUniqueError": "Le nom du rôle doit être unique",
      "roleNameValidationError": "Le nom du rôle doit être alphanumérique",
      "save": "Enregistrer",
      "selectOneOrMoreLabel": "Sélectionner un ou plusieurs",
      "selectOnlyOneLabel": "Sélectionner un seul",
      "selfSignature": "Votre signature",
      "sendAgreement": {
        "assignRequestBody": "Affecter l'utilisateur signataire du contrat à toutes les demandes d'engagement du client",
        "assignRequestTitle": "Affecter la demande à l'utilisateur signataire du contrat",
        "changeTemplate": "Modifier le modèle",
        "document": "document",
        "eSignaturePermissionErrorMessage": "Vous n'avez pas accès aux signatures. Contactez l'administrateur si vous avez besoin d'un accès.",
        "nextTemplate": "Suivant : sélectionner un modèle",
        "selectTemplateTitle": "Sélectionner le modèle",
        "selectedAgreementTemplate": "Modèle de contrat sélectionné",
        "selectedClient": "Client sélectionné",
        "shareRequestBody": "Partager la demande affectée",
        "shareRequestTitle": "Partager la demande",
        "signatureDescription": "Lorsque le contrat est rempli et signé",
        "stepsTitle": "Étapes du workflow d'envoi de contrat",
        "title": "Envoyer le contrat"
      },
      "setSigningOrder": "Définir ordre de signature",
      "setToDateOfExecution": "Défini sur la date d'exécution",
      "shareFileFolder": {
        "selectShareFileFolder": {
          "cancelButtonLabel": "Annuler",
          "createFolderLabel": "Créer dossier",
          "disabledNodeAdminReason": "Une autorisation d'administrateur est nécessaire pour sélectionner ce dossier",
          "disabledSharedFoldersReason": "Impossible de sélectionner des dossiers partagés de niveau supérieur",
          "modalTitle": "Emplacement de stockage des documents signés",
          "selectFolderButtonLabel": "Sélectionner dossier"
        }
      },
      "sharedFolders": "Dossiers partagés",
      "signature": "Signature",
      "signatureAnnotationMessage": "Cliquez et faites glisser pour dessiner votre signature dans la boîte",
      "signatureAnnotationTextMessage": "Tapez votre signature dans le champ ci-dessous",
      "signatureRequest": {
        "closeDrawerModalContent": "Si vous fermez cette demande maintenant, vous perdrez votre progression et devrez recommencer",
        "closeDrawerModalTitle": "Abandonner la demande de signature"
      },
      "signatureRequestErrorMessage": "La demande de signature a échoué",
      "signerDescription": "Vous devez placer des champs pour chaque rôle",
      "signers": "Signataires",
      "startPage": {
        "addAnotherRole": "Ajouter un autre rôle",
        "addNewRole": "Ajouter un nouveau rôle",
        "deleteButtonAriaLabel": "Supprimer le rôle {{roleName}}",
        "dragRoleAriaLabel": "Faire glisser le rôle {{roleName}}",
        "footerButton": "Étape suivante : placer des champs",
        "navigateAwayDialog": {
          "continue": "Continuer",
          "dontShowAgain": "Ne plus afficher ce message",
          "moveAwaySelections": "Si vous quittez votre dossier actuel, vos sélections seront perdues."
        },
        "roleDescription": "Créez un rôle pour chaque personne qui signera le document. La personne qui utilisera ce modèle spécifiera une adresse e-mail pour chaque rôle",
        "roleLabel": "Rôles des signataires",
        "roleName": "Nom du rôle",
        "sequenceInputAriaLabel": "Entrer la séquence du rôle {{roleName}}",
        "setSignerSequence": "Définir la séquence des signataires"
      },
      "started_onboarding_agreement_flow": "Démarrage du flux du contrat d'onboarding",
      "templateCreationNotificationMessage": "Modèle {<templateName>} créé",
      "text": "Texte",
      "textAlignLabel": "Aligner le texte",
      "type": "Type",
      "unknown": "Inconnu",
      "uploadDocumentErrorMessage": "Chargez un document pour passer à l'étape suivante",
      "uploadDocxFileModal": {
        "fileTypeErrorNotification": "Only DOCX files are supported",
        "okButtonText": "Create template",
        "title": "Upload DOCX file",
        "uploadTypes": {
          "computer": {
            "browse": "browse",
            "dragFilesHereOr": "Drag files here or"
          },
          "sharefile": "From ShareFile"
        }
      },
      "variableNameValidationError": "Le nom de la variable doit être alphanumérique",
      "variables": {
        "addAnotherVariable": "Ajouter une autre variable",
        "addNewVariable": "Ajouter une nouvelle variable",
        "dataSource": "Source de données",
        "deleteButtonAriaLabel": "Supprimer la variable {{variableName}}",
        "description": "Utilisez des variables dans votre modèle afin que les informations qu'elles contiennent puissent être remplies automatiquement. Vous pouvez sélectionner le type et la source des données. Lorsque l'expéditeur utilisera le modèle, il spécifiera les données à sélectionner.",
        "errorMessages": {
          "invalidDataSource": "Vous devez spécifier une source de données pour chaque variable",
          "invalidName": "Vous devez spécifier un nom pour chaque variable",
          "invalidSourceRecord": "Vous devez spécifier un enregistrement source pour chaque variable",
          "uniqueName": "Le nom de la variable doit être unique"
        },
        "fieldsAssignedWarningHeader": "Champs affectés à une variable",
        "fieldsAssignedWarningMessage": "Tous les champs affectés à la variable seront supprimés.",
        "label": "Variable",
        "missingDatasourceIntegration": {
          "addIntegrationBody": "Accédez à :  compte > Connexions > ajouter nouvelle connexion.",
          "addIntegrationHeader": "Pour ajouter une nouvelle intégration",
          "message": "Votre compte ne dispose d'aucune connexion tierce pour le moment.\n"
        },
        "sourceRecord": "Enregistrement source",
        "variableName": "Nom de variable"
      },
      "zoomIn": "Zoom avant",
      "zoomOut": "Zoom arrière"
    }
  },
  {
    "key": "it",
    "content": {
      "PaymentFieldLabel": "Riscuoti pagamento",
      "SelectFieldLabel": "Elenco a discesa",
      "SendSignatureRequest": {
        "addFieldDataPanel": {
          "autofilledToastMessage": "Populated {{numberOfFieldsCompleted}} fields",
          "autofilledToastWarningDescription": "We weren’t able to populate every field. You can still continue to next step",
          "autofilledToastWarningMessage": "Populated {{numberOfFieldsFilled}} out of {{totalNumberOfFields}} fields",
          "editVariableNote": "Once you enter value here, click on Update fields to fill this value in the document",
          "editedField": "Edited",
          "enterFieldValue": "Enter field value",
          "generateDocumentModal": {
            "cancelButtonText": "Cancel",
            "confirmButtonText": "Generate",
            "description": "Are you sure you’re ready to generate this document? Please note that once it’s generated, you won’t be able to make changes to any fields.",
            "title": "Generate document"
          },
          "invalidMailMessage": "Please enter a valid email address",
          "notFilled": "Not filled",
          "pending": "In sospeso",
          "populatingFields": "Populating fields",
          "signersFieldEdited": "You have edited some fields but they are not updated in the document. Click on 'Update fields' before moving on.",
          "trackFieldsLabel": "Track fields linked with {{variableName}} ({{filledFields}}/{{totalFields}}) filled",
          "updateFields": "Update fields",
          "variableNotPresentAtSource": "Variable not present at source"
        },
        "documentNameError": "Immettere il nome di un documento",
        "expirationDaysNotificationMessage": "Scegliere una data di scadenza",
        "footer": {
          "changeTemplate": "Cambia modello",
          "generateDocument": "Generate document",
          "sendForSignatureProgressMessage": "Preparazione del documento. Non fare clic sul pulsante Aggiorna o Indietro",
          "sendRequest": "Send for Signature",
          "startOver": "Start over"
        },
        "generatingAndMergingDocumentText": "Just setting things up from your template — almost there!",
        "noVariableComponentInfoModal": {
          "cancelButtonText": "Indietro",
          "confirmButtonText": "Continua comunque",
          "description": "Se si procede al passaggio successivo senza specificare queste variabili, i campi dipendenti rimarranno vuoti.",
          "subtitle": "Le seguenti variabili sono attualmente non specificate:",
          "title": "Hai dimenticato di specificare qualche variabile?"
        },
        "populateFields": "Populate fields",
        "rightPanel": {
          "SignerNotePlaceholder": "Aggiungi nota per tutti i firmatari",
          "days": "giorno/i",
          "documentName": "Nome documento",
          "downloadDocument": "Scarica documento",
          "edit": "Modifica",
          "email": "E-mail",
          "emailPlaceholder": "Immettere l'indirizzo e-mail del destinatario",
          "emptyListMessage": "Quando si inizia a digitare, i valori delle variabili corrispondenti verranno visualizzati qui",
          "expiration": "Scadenza",
          "expirationDateMessage": "Data di scadenza: {{expirationDate}}",
          "expirationDaysError": "Inserire un numero compreso tra 1 e 365",
          "expirationDaysLabel": "giorno/i",
          "name": "Nome",
          "namePlaceholder": "Immettere il nome del destinatario",
          "noResults": "Nessun risultato trovato per la ricerca",
          "recipientEmailPlaceholder": "Immettere l'indirizzo e-mail del destinatario",
          "recipientNamePlaceholder": "Immettere il nome del destinatario",
          "searching": "Ricerca",
          "securityOptions": "Opzioni di sicurezza",
          "sharefileContactsCallErrorMessage": "Impossibile ottenere i valori delle variabili a causa di un problema dei contatti di ShareFile. Cancellare la ricerca e riprovare",
          "signerNote": "Nota per tutti i firmatari",
          "storageLocation": "Posizione di archiviazione del documento firmato"
        },
        "securityOptions": {
          "generateNewPasscode": "Genera nuovo",
          "kbaAlert": "I firmatari avranno l'accesso al documento bloccato dopo 3 tentativi falliti.",
          "kbaDescription": "Richiedere ai destinatari di verificare la propria identità con un quiz basato sulla conoscenza. Ogni firmatario dovrà eseguire la verifica autonomamente prima di firmare il documento.",
          "kbaLabel": "Autenticazione basata sulla conoscenza",
          "none": "Nessuno",
          "passcodeAlert": "Si dovrà condividere questo passcode con ogni destinatario.",
          "passcodeBlankError": "Immettere un passcode",
          "passcodeDescription": "I destinatari devono immettere un passcode di {<fiveDigit>} per accedere ai documenti.",
          "passcodeFiveDigit": "5 cifre",
          "passcodeLabel": "Passcode",
          "passcodeLengthError": "Il passcode deve avere 5 cifre",
          "passcodeOnlyDigits": "Il passcode può contenere solo cifre.",
          "passcodePlaceholder": "Immettere o generare un passcode",
          "save": "Salva",
          "title": "Opzioni di sicurezza"
        },
        "signatureRequestFailureMessage": "Impossibile inviare la richiesta di firma",
        "signatureRequestSuccessNotification": {
          "message": "Sent signature request",
          "viewButton": "View request"
        },
        "tag": "Modello",
        "title": "Richiesta di firma",
        "variables": {
          "description": "Selezionare un valore per ogni variabile per compilare automaticamente con i dati nel passaggio successivo",
          "noVariablesSelectedError": "Selezionare tutte le variabili.",
          "placeholder": "Digitare per trovare la variabile corrispondente",
          "salesforceIntegrationErrorMsg": "Impossibile ottenere i valori delle variabili a causa di un problema di integrazione di Salesforce. Controllare le impostazioni di integrazione",
          "subTitle": "Choose variable",
          "title": "Populate fields"
        },
        "viewRequest": "View request"
      },
      "SignatureFieldLabel": "Firma",
      "TextFieldLabel": "Testo",
      "add": "Aggiungi",
      "addCheckbox": "Aggiungi casella di controllo",
      "addFilesFromSharefile": "Aggiungi elementi da ShareFile",
      "addMyself": "Aggiungi mittente come ruolo",
      "addOptionLabel": "Aggiungi opzione",
      "addRole": "Aggiungi un altro ruolo",
      "addSignature": "Aggiungi firma",
      "annotator": "Tu (ora)",
      "annotatorOptionTooltip": "Compila i campi in anticipo",
      "apply": "Applica",
      "assignedToLabel": "Assegnato a",
      "cancel": "Annulla",
      "checkbox": "Casella di controllo",
      "checkboxGroup": "Gruppo di caselle di controllo",
      "checkboxes": "Caselle di controllo",
      "clear": "Cancella",
      "close": "Chiudi",
      "components": {
        "attachment": "Allegato",
        "editor": {
          "defaultHelpText": "Carica qui l'allegato",
          "fontSizeLabel": "Dimensione del carattere",
          "helpTextLabel": "Aggiungi testo della Guida"
        }
      },
      "confirm": "Conferma",
      "createDocumentTemplateModal": {
        "description": "Create a template to generate PDF documents and send them for e-signature",
        "features": {
          "addFields": "Add fields such as text, date, or signature for signers to fill out",
          "systemFilledData": "Optionally use data from your system to automatically fill the fields"
        },
        "templates": {
          "dynamic": {
            "description": "A reusable template, generated from a PDF or DOCX file. {<lineBreak>} Ideal if the file won’t change often—great for standard forms and contracts."
          },
          "editableWord": {
            "alertMessage": "You'll need to install ShareFile's Word add-in",
            "description": "A reusable template, directly editable in Microsoft Word using ShareFile's Word add-in. {<lineBreak>} Best for templates that need frequent content updates."
          },
          "title": "Select template type"
        },
        "title": "Create document template"
      },
      "createdTemplateSuccess": "Modello di documento creato",
      "dashboard": {
        "card": {
          "createdBy": "Creato da"
        },
        "createTemplateButton": "Nuovo modello di documento",
        "loading": "Caricamento...",
        "title": "Modelli"
      },
      "date": "Data",
      "dateExample": "Esempio:",
      "dateFormatLabel": "Formato",
      "dateSignedLabel": "Compilazione automatica data di firma",
      "dateSignedTooltip": "Un destinatario non sarà in grado di modificare il campo. Sarà compilato automaticamente il giorno in cui il documento viene firmato.",
      "defaultValueLabel": "Aggiungere testo predefinito",
      "deleteConfirmationModal": {
        "cancelButton": "Cancel",
        "cancelButtonText": "Continua a modificare",
        "confirmButtonText": "Scarta",
        "okButtonText": "Ok"
      },
      "deleteDetails": {
        "deleteConfirmation": {
          "content": "Are you sure you want to delete the {<templateName>} template? The template will be permanently deleted. If this template is shared, users will lose access",
          "title": "Are you sure you want to delete this template?"
        },
        "notification": {
          "successMessage": "Template Deleted Successfully"
        }
      },
      "description": "Descrizione",
      "details": {
        "actionItems": {
          "addToMyTemplates": "Aggiungi ai miei modelli",
          "delete": "Delete template",
          "download": "Scarica",
          "edit": "Modifica",
          "sendAsSignatureRequest": "Invia come richiesta di firma",
          "share": "Condividi",
          "useAsDocument": "Utilizza come documento"
        },
        "documentTemplate": "modello di documento",
        "overview": {
          "createdBy": "Creato da",
          "cretedOn": "Creato il",
          "description": "Descrizione",
          "doc": "DOC",
          "edit": "Modifica",
          "pdf": "PDF",
          "tabs": {
            "fields": "Campi",
            "overview": "Panoramica"
          }
        },
        "settings": {
          "disabled": "Disabilitato",
          "enabled": "Abilitato",
          "kbaRequirement": "Requisito KBA",
          "passcode": "Passcode",
          "title": "Impostazioni applicate"
        },
        "shareTemplateSuccess": "Modello di documento condiviso",
        "title": "Modello di documento"
      },
      "discardTemplate": {
        "cancelButtonText": "Continua a modificare",
        "confirmButtonText": "Scarta",
        "content": "Chiudendo ora, si perderanno i progressi e si dovrà ricominciare da capo",
        "title": "Scarta modello"
      },
      "docTemplateListing": {
        "button": "Crea",
        "emptyState": {
          "button": "Crea modello",
          "subtitle": "Iniziare a utilizzare i modelli per evitare di ricreare i documenti",
          "title": "Creare il primo modello di documento"
        },
        "noSearchResults": {
          "subtitle": "Impossibile trovare {<searchTerm>} in alcun titolo o descrizione di modello.",
          "title": "La ricerca non ha trovato corrispondenze in alcun modello"
        }
      },
      "documentThumbnailAltText": "Nessuna miniatura disponibile",
      "documentToSend": "Seleziona documento",
      "documentView": {
        "documentPageIndex": "Pagina {<currentPage>} di {{totalPages}}",
        "pageChangeInputLabel": "Cambia pagina in",
        "pageDown": "Pagina successiva",
        "pageUp": "Pagina precedente"
      },
      "draw": "Disegna",
      "dropdownInsufficientOptionsError": "Ogni elenco a discesa deve avere almeno 2 opzioni",
      "edit": {
        "cancelText": "Cancel",
        "checkedOutInfo": "We can’t rename, move, or delete files while they’re being edited. We also can’t upload files that have the same name.",
        "checkedOutTitle": "This file is being edited",
        "closeText": "Close",
        "edit": "Edit",
        "editDesktopConfirmMessage": "Make sure you're signed in to ShareFile.",
        "editDesktopOpenMessage": " should have opened in Microsoft {{appType}} on your desktop application.",
        "editDesktopTitle": "Create in Microsoft {{appType}}",
        "editDesktopWarning": "If you don't have Microsoft Word, you can still ",
        "editError": "Error occurred while initializing Edit session. Please try again.",
        "editInMicrosoftWord": "Edit in Microsoft Word",
        "editOnline": "Edit online",
        "editOnlineLearnText": "Learn more about editing online.",
        "editOnlineOpenMessage": " should have opened in Microsoft {{appType}} Online in a new tab.",
        "editOnlineText": "edit online.",
        "editOnlineTitle": "Edit Online",
        "editTroubleText": "Having trouble? ",
        "learnMoreText": "Learn more.",
        "signInCheckboxText": "I've signed in to ShareFile",
        "signInMessage": "Before you can open files in Microsoft {{appType}}, you need to sign in to ShareFile. You'll only need to do this once. ",
        "signInPostScriptText": "After you sign in, come back to this page to open the document.",
        "signInSharefileTitle": "Sign in to ShareFile",
        "signInText": "Sign In",
        "tryAgainText": "Try Again"
      },
      "emptyFolder": "La cartella è vuota",
      "emptyRoleName": "Questo campo è obbligatorio",
      "errorMessages": {
        "createDocumentError": "Impossibile creare il documento",
        "createDocumentTemplateError": "Impossibile creare il modello di documento",
        "deleteUploadedFileError": "Impossibile eliminare il file",
        "fetchDataSourcesError": "Impossibile recuperare l'origine dati",
        "fetchEntitiesError": "Impossibile recuperare le entità",
        "fetchFileError": "Failed to download file",
        "fetchPdfFileError": "Impossibile scaricare il file PDF",
        "fetchSchemaError": "Impossibile recuperare lo schema",
        "fetchThumbnailUrlError": "Impossibile recuperare la miniatura",
        "generateDocumentError": "Failed to generate document",
        "getDocumentError": "Impossibile recuperare il documento",
        "getDocumentTemplateError": "Impossibile recuperare il modello di documento",
        "getTemplatesError": "Impossibile recuperare i modelli",
        "saveVariablesError": "Impossibile salvare la variabile",
        "updateDocumentError": "Impossibile salvare il documento",
        "updateDocumentTemplateError": "Impossibile salvare il modello",
        "uploadFileError": "Impossibile caricare il file"
      },
      "extensionSlots": {
        "createNewTemplate": "Nuovo modello di documento",
        "dashboardShortcut": "Crea modello di documento",
        "templates": "Modelli"
      },
      "favorites": "Preferiti",
      "fieldNameLabel": "Nome del campo",
      "fieldRequired": "Questo campo è obbligatorio",
      "fields": "Campi",
      "fieldsAssignedWarningHeader": "Campi assegnati ai ruoli",
      "fieldsAssignedWarningMessage": "Tutti i campi assegnati ai ruoli verranno rimossi.",
      "fileNotSupportedTooltip": "Formato di file non supportato",
      "footer": {
        "previousButton": "Passaggio precedente"
      },
      "genericError": "Qualcosa e' andato storto. Si prega di riprovare",
      "groupNameLabel": "Assegna nome a gruppo",
      "groupRule": "Regola di gruppo",
      "hasAtleastOneRoleErrorMessage": "Aggiungere almeno un ruolo per procedere",
      "header": {
        "stepper": {
          "stepOne": "Preparare il modello",
          "stepThree": "Rivedi e salva",
          "stepTwo": "Aggiungi campi"
        },
        "title": "Crea modello"
      },
      "initials": "Iniziali",
      "invalidDocgenRequest": "La richiesta di firma sembra non valida, verificare l'URL",
      "invalidEmail": "E-mail non valido",
      "invalidRecipientErrorMessage": "È necessario specificare un nome e di un indirizzo e-mail per ogni destinatario",
      "invalidRoleErrorMessage": "È necessario un nome per ogni ruolo",
      "label": "Etichetta",
      "leftNav": {
        "annotateDescription": "Utilizzare questi campi per aggiungere etichette, caselle di controllo o annotazioni di altro tipo ai documenti PDF.",
        "annotateDocument": "Annota il documento",
        "senderFields": "Campi compilati dal mittente",
        "signerFields": "Campi compilati dal firmatario",
        "signerFilled": {
          "addRoles": "Aggiungere ruoli",
          "descriptionNoRoles": "Assegnare un ruolo a ogni persona che parteciperà al processo documentale (se applicabile).\n\nAd esempio, in un contratto legale, si potrebbero creare ruoli di \"Cliente\", \"Avvocato\" e \"Testimone\".\n\nQuando qualcuno utilizza il modello, dovrà semplicemente assegnare un indirizzo e-mail a ciascun ruolo. Ciò garantisce che tutti ricevano la versione corretta del documento e semplifica il processo di firma",
          "descriptionWithRoles": "Aggiungere i campi che devono essere compilati dagli utenti che ricevono questo modello",
          "dropdownDescription": "Verranno aggiunti campi per il ruolo di {{roleName}}",
          "manageRoles": "Gestire i ruoli",
          "role": "Ruolo",
          "title": "Compilato dal firmatario"
        },
        "systemFilled": {
          "addVariables": "Aggiungi variabili",
          "descriptionNoVariables": "Per aggiungere dati dinamici al modello, utilizzare le variabili.\n\nA questo punto, selezionare l'origine dati e il tipo di record. In seguito, quando qualcuno utilizzerà il modello, sceglierà il tipo di record da utilizzare.",
          "descriptionWithVariables": "Per aggiungere dati dinamici al modello, utilizzare le variabili.",
          "dropdownDescription": "Si dovranno aggiungere i dati tratti da ogni variabile",
          "manageVariables": "Gestire le variabili",
          "searchData": "Dati di ricerca",
          "title": "Compilato dal sistema",
          "toolTip": "Campi compilati dal sistema",
          "variable": "Variabile"
        }
      },
      "maxFileSizeLimitMessage": "The maximum file size supported is 20 MB",
      "multiLineLabel": "Consenti più righe",
      "name": "Nome",
      "noSignerComponentInfoModal": {
        "cancelButtonText": "Indietro",
        "confirmButtonText": "Continua comunque",
        "description": "È possibile passare al passaggio successivo comunque, oppure tornare indietro e aggiungere dei campi da compilare.",
        "subtitle": "Questi ruoli non hanno nulla da firmare:",
        "title": "Hai dimenticato dei campi?"
      },
      "optionsLabel": "Opzioni",
      "paymentAmountInvalidError": "Inserire un importo di pagamento per continuare",
      "personalFolders": "Cartelle personali",
      "preparePage": {
        "footerButton": "Passaggio successivo"
      },
      "previous": "Indietro",
      "radio": "Gruppo di pulsanti di opzione",
      "readyState": "Pronto!",
      "reasonDeclineLabel": "Motivo del rifiuto",
      "reasonVoidLabel": "Motivo dell'annullamento",
      "recipientListHeading": "Di quali ruoli ha bisogno questo modello?",
      "recipientName": "Nome",
      "recipientRemindButtonLabel": "Invia promemoria",
      "recipientRole": "Ruolo",
      "recipientRoleSigner": "Firmatario",
      "recipientRoleViewer": "Partecipante",
      "recipientStatusSigned": "Firmato",
      "recipientUniqueEmailErrorMessage": "L'indirizzo e-mail del destinatario deve essere univoco.",
      "recipientUnlockLabel": "Sblocca",
      "recipientsLabel": "Destinatari",
      "recordType": "Tipo di record",
      "referenceIdLabel": "ID di riferimento",
      "reminderSent": "Promemoria inviato",
      "removeFieldLabel": "Rimuovi campo",
      "requiredFieldLabel": "Campo obbligatorio",
      "reviewAndSave": "Rivedi e salva",
      "reviewPage": {
        "descriptionPlaceholderText": "Inserisci il testo della descrizione",
        "footerButton": "Salva modello",
        "kbaRequirement": "Requisito KBA",
        "kbaTooltip": "Richiedere ai firmatari di verificare la propria identità con un quiz basato sulla conoscenza. Ogni firmatario dovrà eseguire la verifica autonomamente prima di firmare il documento.",
        "passCodeTooltip": "I destinatari devono immettere un passcode di 5 cifre per accedere ai documenti.",
        "passcodeLabel": "Passcode",
        "securityOptionsLabel": "Opzioni di sicurezza",
        "templateNameBlank": "Immetti un nome per il modello",
        "templatePlaceholderText": "Immettere il nome del modello"
      },
      "roleNameUniqueError": "Il nome del ruolo deve essere univoco",
      "roleNameValidationError": "Il nome del ruolo deve essere alfanumerico",
      "save": "Salva",
      "selectOneOrMoreLabel": "Selezionare uno o più",
      "selectOnlyOneLabel": "Selezionare solo uno",
      "selfSignature": "La tua firma",
      "sendAgreement": {
        "assignRequestBody": "Assegnare all'utente che ha firmato l'accordo tutte le richieste del cliente che fanno parte dell'incarico",
        "assignRequestTitle": "Assegna la richiesta all'utente che ha firmato l'accordo",
        "changeTemplate": "Cambia modello",
        "document": "documento",
        "eSignaturePermissionErrorMessage": "Non hai accesso alle firme. Contatta l'amministratore se hai bisogno di accedere.",
        "nextTemplate": "Successivo: Seleziona Modello",
        "selectTemplateTitle": "Seleziona modello",
        "selectedAgreementTemplate": "Modello di contratto selezionato",
        "selectedClient": "Cliente selezionato",
        "shareRequestBody": "Condividi la richiesta assegnata",
        "shareRequestTitle": "Condividi la richiesta",
        "signatureDescription": "Quando l'accordo è firmato e completato",
        "stepsTitle": "Passaggi del flusso di lavoro per l'invio del contratto",
        "title": "Invia contratto"
      },
      "setSigningOrder": "Imposta l'ordine di firma",
      "setToDateOfExecution": "Impostato sulla data di esecuzione",
      "shareFileFolder": {
        "selectShareFileFolder": {
          "cancelButtonLabel": "Annulla",
          "createFolderLabel": "Crea cartella",
          "disabledNodeAdminReason": "È necessaria l'autorizzazione di amministratore per selezionare questa cartella",
          "disabledSharedFoldersReason": "Impossibile selezionare le cartelle condivise del livello più alto",
          "modalTitle": "Posizione di archiviazione del documento firmato",
          "selectFolderButtonLabel": "Seleziona cartella"
        }
      },
      "sharedFolders": "Cartelle condivise",
      "signature": "Firma",
      "signatureAnnotationMessage": "Fai clic e trascina per disegnare la firma nella casella",
      "signatureAnnotationTextMessage": "Digita la tua firma nel campo sottostante",
      "signatureRequest": {
        "closeDrawerModalContent": "Chiudendo ora questa richiesta, si perderanno i progressi e si dovrà ricominciare da capo",
        "closeDrawerModalTitle": "Scarta la richiesta di firma"
      },
      "signatureRequestErrorMessage": "Richiesta di firma non riuscita",
      "signerDescription": "Si inseriranno campi per ciascun ruolo",
      "signers": "Firmatari",
      "startPage": {
        "addAnotherRole": "Aggiungi un altro ruolo",
        "addNewRole": "Aggiungi un nuovo ruolo",
        "deleteButtonAriaLabel": "Elimina il ruolo {{roleName}}",
        "dragRoleAriaLabel": "Trascina il ruolo {{roleName}}",
        "footerButton": "Successivo: Posizionamento dei campi",
        "navigateAwayDialog": {
          "continue": "Continua",
          "dontShowAgain": "Non mostrare questo messaggio in futuro",
          "moveAwaySelections": "Se si abbandona la cartella corrente, le selezioni andranno perse."
        },
        "roleDescription": "Assegna un ruolo a ogni persona che firmerà il documento. Ogni volta che qualcuno utilizza questo modello, fornirà un indirizzo e-mail per ciascun ruolo",
        "roleLabel": "Ruoli dei firmatari",
        "roleName": "Nome del ruolo",
        "sequenceInputAriaLabel": "Inserisci la sequenza per il ruolo {{roleName}}",
        "setSignerSequence": "Imposta la sequenza dei firmatari"
      },
      "started_onboarding_agreement_flow": "Avvio del flusso del contratto di integrazione",
      "templateCreationNotificationMessage": "Modello {<templateName>} creato",
      "text": "Testo",
      "textAlignLabel": "Allinea il testo",
      "type": "Tipo",
      "unknown": "Sconosciuto",
      "uploadDocumentErrorMessage": "Carica un documento per andare al passaggio successivo",
      "uploadDocxFileModal": {
        "fileTypeErrorNotification": "Only DOCX files are supported",
        "okButtonText": "Create template",
        "title": "Upload DOCX file",
        "uploadTypes": {
          "computer": {
            "browse": "browse",
            "dragFilesHereOr": "Drag files here or"
          },
          "sharefile": "From ShareFile"
        }
      },
      "variableNameValidationError": "Il nome della variabile deve essere alfanumerico",
      "variables": {
        "addAnotherVariable": "Aggiungi un'altra variabile",
        "addNewVariable": "Aggiungi una nuova variabile",
        "dataSource": "Fonte dei dati",
        "deleteButtonAriaLabel": "Elimina la variabile {{variableName}}",
        "description": "Utilizza le variabili disponibili nel modello in modo che le informazioni possano essere inserite automaticamente. È possibile selezionare il tipo di dati e l'origine dei dati. Quando si utilizza il modello, il mittente specificherà i dati da selezionare.",
        "errorMessages": {
          "invalidDataSource": "È necessaria una fonte di dati per ogni variabile",
          "invalidName": "È necessario un nome per ogni variabile",
          "invalidSourceRecord": "È necessario un record di origine per ogni variabile",
          "uniqueName": "Il nome della variabile deve essere univoco"
        },
        "fieldsAssignedWarningHeader": "Campi assegnati alla variabile",
        "fieldsAssignedWarningMessage": "Tutti i campi assegnati alla variabile verranno rimossi.",
        "label": "Variabile",
        "missingDatasourceIntegration": {
          "addIntegrationBody": "Vai a: account > Connessioni > aggiungi nuova connessione.",
          "addIntegrationHeader": "Per aggiungere una nuova integrazione",
          "message": "Al momento l'account non ha connessioni di terze parti.\n"
        },
        "sourceRecord": "Record di origine",
        "variableName": "Nome della variabile"
      },
      "zoomIn": "Ingrandisci",
      "zoomOut": "Riduci"
    }
  },
  {
    "key": "ja",
    "content": {
      "PaymentFieldLabel": "支払いを指定",
      "SelectFieldLabel": "ドロップダウン",
      "SendSignatureRequest": {
        "addFieldDataPanel": {
          "autofilledToastMessage": "Populated {{numberOfFieldsCompleted}} fields",
          "autofilledToastWarningDescription": "We weren’t able to populate every field. You can still continue to next step",
          "autofilledToastWarningMessage": "Populated {{numberOfFieldsFilled}} out of {{totalNumberOfFields}} fields",
          "editVariableNote": "Once you enter value here, click on Update fields to fill this value in the document",
          "editedField": "Edited",
          "enterFieldValue": "Enter field value",
          "generateDocumentModal": {
            "cancelButtonText": "Cancel",
            "confirmButtonText": "Generate",
            "description": "Are you sure you’re ready to generate this document? Please note that once it’s generated, you won’t be able to make changes to any fields.",
            "title": "Generate document"
          },
          "invalidMailMessage": "Please enter a valid email address",
          "notFilled": "Not filled",
          "pending": "保留中",
          "populatingFields": "Populating fields",
          "signersFieldEdited": "You have edited some fields but they are not updated in the document. Click on 'Update fields' before moving on.",
          "trackFieldsLabel": "Track fields linked with {{variableName}} ({{filledFields}}/{{totalFields}}) filled",
          "updateFields": "Update fields",
          "variableNotPresentAtSource": "Variable not present at source"
        },
        "documentNameError": "ドキュメント名を入力してください",
        "expirationDaysNotificationMessage": "有効期限を選択する",
        "footer": {
          "changeTemplate": "テンプレートを変更する",
          "generateDocument": "Generate document",
          "sendForSignatureProgressMessage": "ドキュメントを準備しています。「更新」または「戻る」ボタンをクリックしないでください。",
          "sendRequest": "Send for Signature",
          "startOver": "Start over"
        },
        "generatingAndMergingDocumentText": "Just setting things up from your template — almost there!",
        "noVariableComponentInfoModal": {
          "cancelButtonText": "戻る",
          "confirmButtonText": "このまま続行する",
          "description": "これらの変数を入力せずに次の手順に進むと、関連フィールドは空のままになります。",
          "subtitle": "次の変数が現在空です:",
          "title": "変数の入力を忘れていませんか?"
        },
        "populateFields": "Populate fields",
        "rightPanel": {
          "SignerNotePlaceholder": "すべての署名者へのメモを追加する",
          "days": "日",
          "documentName": "ドキュメント名",
          "downloadDocument": "ドキュメントをダウンロードする",
          "edit": "編集",
          "email": "メール アドレス",
          "emailPlaceholder": "受信者のメール アドレスを入力する",
          "emptyListMessage": "入力を開始すると、一致する変数値がここに表示されます",
          "expiration": "有効期限",
          "expirationDateMessage": "有効期限日: {{expirationDate}}",
          "expirationDaysError": "1 ～ 365 の数字を入力してください",
          "expirationDaysLabel": "日",
          "name": "名前",
          "namePlaceholder": "受信者の名前を入力する",
          "noResults": "検索結果が見つかりません",
          "recipientEmailPlaceholder": "受信者のメール アドレスを入力する",
          "recipientNamePlaceholder": "受信者の名前を入力する",
          "searching": "検索中",
          "securityOptions": "セキュリティ オプション",
          "sharefileContactsCallErrorMessage": "ShareFile の連絡先に問題があるため、変数値を取得できません。検索をクリアしてもう一度お試しください",
          "signerNote": "すべての署名者へのメモ",
          "storageLocation": "署名済みドキュメントの保存場所"
        },
        "securityOptions": {
          "generateNewPasscode": "新しく生成する",
          "kbaAlert": "3 回失敗すると、署名者はドキュメントからロック アウトされます。",
          "kbaDescription": "受信者は、ナレッジベースに登録された本人確認のための質問に回答する必要があります。署名者ごとに、ドキュメントに署名する前に確認を求められます。",
          "kbaLabel": "ナレッジベース認証",
          "none": "なし",
          "passcodeAlert": "このパスコードを各受信者と共有する必要があります。",
          "passcodeBlankError": "パスコードを入力してください。",
          "passcodeDescription": "受信者がドキュメントにアクセスするには、 {<fiveDigit>} のパスコードを入力する必要があります。",
          "passcodeFiveDigit": "5 桁",
          "passcodeLabel": "パスコード",
          "passcodeLengthError": "パスコードには 5 桁の数字が必要です",
          "passcodeOnlyDigits": "パスコードには数字のみを含めることができます。",
          "passcodePlaceholder": "パスコードを入力または生成する",
          "save": "保存",
          "title": "セキュリティ オプション"
        },
        "signatureRequestFailureMessage": "署名リクエストを送信できませんでした",
        "signatureRequestSuccessNotification": {
          "message": "Sent signature request",
          "viewButton": "View request"
        },
        "tag": "テンプレート",
        "title": "署名リクエスト",
        "variables": {
          "description": "次の手順でデータを自動入力するには、各変数の値を選択します。",
          "noVariablesSelectedError": "すべての変数を選択してください。",
          "placeholder": "一致する変数を検索するために入力",
          "salesforceIntegrationErrorMsg": "Salesforce 統合の問題により変数値を取得できません。統合設定を確認してください。",
          "subTitle": "Choose variable",
          "title": "Populate fields"
        },
        "viewRequest": "View request"
      },
      "SignatureFieldLabel": "署名",
      "TextFieldLabel": "文字列",
      "add": "追加",
      "addCheckbox": "チェックボックスを追加する",
      "addFilesFromSharefile": "ShareFile からアイテムを追加",
      "addMyself": "送信者を役割として追加する",
      "addOptionLabel": "オプションを追加",
      "addRole": "別の役割を追加する",
      "addSignature": "署名を追加する",
      "annotator": "あなた (現時点)",
      "annotatorOptionTooltip": "事前にフィールドに記入してください",
      "apply": "適用",
      "assignedToLabel": "割り当て先",
      "cancel": "キャンセル",
      "checkbox": "チェックボックス",
      "checkboxGroup": "チェックボックス グループ",
      "checkboxes": "チェックボックス",
      "clear": "クリア",
      "close": "閉じる",
      "components": {
        "attachment": "添付ファイル",
        "editor": {
          "defaultHelpText": "ここに添付ファイルをアップロードする",
          "fontSizeLabel": "フォント サイズ",
          "helpTextLabel": "ヘルプ テキストを追加する"
        }
      },
      "confirm": "確認",
      "createDocumentTemplateModal": {
        "description": "Create a template to generate PDF documents and send them for e-signature",
        "features": {
          "addFields": "Add fields such as text, date, or signature for signers to fill out",
          "systemFilledData": "Optionally use data from your system to automatically fill the fields"
        },
        "templates": {
          "dynamic": {
            "description": "A reusable template, generated from a PDF or DOCX file. {<lineBreak>} Ideal if the file won’t change often—great for standard forms and contracts."
          },
          "editableWord": {
            "alertMessage": "You'll need to install ShareFile's Word add-in",
            "description": "A reusable template, directly editable in Microsoft Word using ShareFile's Word add-in. {<lineBreak>} Best for templates that need frequent content updates."
          },
          "title": "Select template type"
        },
        "title": "Create document template"
      },
      "createdTemplateSuccess": "ドキュメント テンプレートが作成されました",
      "dashboard": {
        "card": {
          "createdBy": "作成者"
        },
        "createTemplateButton": "新規ドキュメント テンプレート",
        "loading": "読み込み中...",
        "title": "テンプレート"
      },
      "date": "日付",
      "dateExample": "例:",
      "dateFormatLabel": "形式",
      "dateSignedLabel": "署名した日付を自動入力",
      "dateSignedTooltip": "受信者はフィールドを編集できません。ドキュメントに署名した日付が自動的に入力されます。",
      "defaultValueLabel": "デフォルトのテキストを追加する",
      "deleteConfirmationModal": {
        "cancelButton": "Cancel",
        "cancelButtonText": "編集を続ける",
        "confirmButtonText": "破棄",
        "okButtonText": "Ok"
      },
      "deleteDetails": {
        "deleteConfirmation": {
          "content": "Are you sure you want to delete the {<templateName>} template? The template will be permanently deleted. If this template is shared, users will lose access",
          "title": "Delete template"
        },
        "notification": {
          "successMessage": "Template deleted successfully"
        }
      },
      "description": "説明",
      "details": {
        "actionItems": {
          "addToMyTemplates": "自分のテンプレートに追加する",
          "delete": "Delete template",
          "download": "ダウンロード",
          "edit": "編集",
          "sendAsSignatureRequest": "署名リクエストとして送信する",
          "share": "共有",
          "useAsDocument": "ドキュメントとして使用する"
        },
        "documentTemplate": "ドキュメント テンプレート",
        "overview": {
          "createdBy": "作成者",
          "cretedOn": "作成日",
          "description": "説明",
          "doc": "DOC",
          "edit": "編集",
          "pdf": "PDF",
          "tabs": {
            "fields": "フィールド",
            "overview": "概要"
          }
        },
        "settings": {
          "disabled": "無効",
          "enabled": "有効",
          "kbaRequirement": "KBA 要件",
          "passcode": "パスコード",
          "title": "設定が適用されました"
        },
        "shareTemplateSuccess": "ドキュメント テンプレートが共有されました",
        "title": "ドキュメント テンプレート"
      },
      "discardTemplate": {
        "cancelButtonText": "編集を続ける",
        "confirmButtonText": "破棄",
        "content": "今これを閉じると、作業中の内容が失われ、最初からやり直す必要があります。",
        "title": "テンプレートを破棄する"
      },
      "docTemplateListing": {
        "button": "作成",
        "emptyState": {
          "button": "テンプレートを作成する",
          "subtitle": "ドキュメントの再作成を避けるために、テンプレートの使用を開始する",
          "title": "最初のドキュメント テンプレートを作成する"
        },
        "noSearchResults": {
          "subtitle": "テンプレートのタイトルや説明に {<searchTerm>} が見つかりませんでした。",
          "title": "検索に一致するテンプレートがありません"
        }
      },
      "documentThumbnailAltText": "サムネイルがありません",
      "documentToSend": "ドキュメントを選択する",
      "documentView": {
        "documentPageIndex": "ページ {<currentPage>}/{{totalPages}}",
        "pageChangeInputLabel": "移動先のページ",
        "pageDown": "次のページ",
        "pageUp": "前のページ"
      },
      "draw": "手書き入力",
      "dropdownInsufficientOptionsError": "各ドロップダウンには少なくとも 2 つのオプションが必要です",
      "edit": {
        "cancelText": "Cancel",
        "checkedOutInfo": "We can’t rename, move, or delete files while they’re being edited. We also can’t upload files that have the same name.",
        "checkedOutTitle": "This file is being edited",
        "closeText": "Close",
        "edit": "Edit",
        "editDesktopConfirmMessage": "Make sure you're signed in to ShareFile.",
        "editDesktopOpenMessage": " should have opened in Microsoft {{appType}} on your desktop application.",
        "editDesktopTitle": "Create in Microsoft {{appType}}",
        "editDesktopWarning": "If you don't have Microsoft Word, you can still ",
        "editError": "Error occurred while initializing Edit session. Please try again.",
        "editInMicrosoftWord": "Edit in Microsoft Word",
        "editOnline": "Edit online",
        "editOnlineLearnText": "Learn more about editing online.",
        "editOnlineOpenMessage": " should have opened in Microsoft {{appType}} Online in a new tab.",
        "editOnlineText": "edit online.",
        "editOnlineTitle": "Edit Online",
        "editTroubleText": "Having trouble? ",
        "learnMoreText": "Learn more.",
        "signInCheckboxText": "I've signed in to ShareFile",
        "signInMessage": "Before you can open files in Microsoft {{appType}}, you need to sign in to ShareFile. You'll only need to do this once. ",
        "signInPostScriptText": "After you sign in, come back to this page to open the document.",
        "signInSharefileTitle": "Sign in to ShareFile",
        "signInText": "Sign In",
        "tryAgainText": "Try Again"
      },
      "emptyFolder": "このフォルダーは空です",
      "emptyRoleName": "このフィールドは必須です",
      "errorMessages": {
        "createDocumentError": "ドキュメントを作成できませんでした",
        "createDocumentTemplateError": "ドキュメント テンプレートを作成できませんでした",
        "deleteUploadedFileError": "ファイルを削除できませんでした",
        "fetchDataSourcesError": "データ ソースを取得できませんでした",
        "fetchEntitiesError": "エンティティを取得できませんでした",
        "fetchFileError": "Failed to download file",
        "fetchPdfFileError": "PDF ファイルをダウンロードできませんでした",
        "fetchSchemaError": "スキーマを取得できませんでした",
        "fetchThumbnailUrlError": "サムネイルを取得できませんでした",
        "generateDocumentError": "Failed to generate document",
        "getDocumentError": "ドキュメントを取得できませんでした",
        "getDocumentTemplateError": "ドキュメント テンプレートを取得できませんでした",
        "getTemplatesError": "テンプレートを取得できませんでした",
        "saveVariablesError": "変数を保存できませんでした",
        "updateDocumentError": "ドキュメントを保存できませんでした",
        "updateDocumentTemplateError": "テンプレートを保存できませんでした",
        "uploadFileError": "ファイルのアップロードに失敗しました"
      },
      "extensionSlots": {
        "createNewTemplate": "新規ドキュメント テンプレート",
        "dashboardShortcut": "ドキュメント テンプレートを作成する",
        "templates": "テンプレート"
      },
      "favorites": "お気に入り",
      "fieldNameLabel": "フィールド名",
      "fieldRequired": "このフィールドは必須です",
      "fields": "フィールド",
      "fieldsAssignedWarningHeader": "役割に割り当てられたフィールド",
      "fieldsAssignedWarningMessage": "役割に割り当てられたすべてのフィールドが削除されます。",
      "fileNotSupportedTooltip": "サポートされていないファイル形式です",
      "footer": {
        "previousButton": "前の手順"
      },
      "genericError": "問題が発生しました。もう一度試してください",
      "groupNameLabel": "グループ名",
      "groupRule": "グループの規則",
      "hasAtleastOneRoleErrorMessage": "続行するには少なくとも 1 つの役割を追加する",
      "header": {
        "stepper": {
          "stepOne": "テンプレートを準備する",
          "stepThree": "確認して保存する",
          "stepTwo": "フィールドを追加する"
        },
        "title": "テンプレートを作成する"
      },
      "initials": "イニシャル",
      "invalidDocgenRequest": "署名リクエストが無効のようです。URL を確認してください",
      "invalidEmail": "無効なメール アドレス",
      "invalidRecipientErrorMessage": "各受信者の名前とメール アドレスを入力する必要があります",
      "invalidRoleErrorMessage": "各役割に名前が必要です",
      "label": "ラベル",
      "leftNav": {
        "annotateDescription": "これらのフィールドを使用して、PDF ドキュメントにラベル、チェックボックス、またはその他の注釈を追加します。",
        "annotateDocument": "ドキュメントに注釈を付ける",
        "senderFields": "送信者が入力したフィールド",
        "signerFields": "署名者が入力したフィールド",
        "signerFilled": {
          "addRoles": "役割を追加する",
          "descriptionNoRoles": "ドキュメント作成プロセスに参加する各ユーザーの役割を作成します。(該当する場合)\n\nたとえば、法的な契約では、「クライアント」、「弁護士」、「証人」の役割を作成できます。\n\nテンプレートを使用する場合は、各役割にメール アドレスを割り当てるだけです。これにより、全員が適切なバージョンのドキュメントを入手し、署名プロセスを効率化できます。",
          "descriptionWithRoles": "このテンプレートを受け取ったユーザーが入力する必要があるフィールドを追加します",
          "dropdownDescription": "{{roleName}} の役割にフィールドを追加します",
          "manageRoles": "役割を管理する",
          "role": "役割",
          "title": "署名者が入力済み"
        },
        "systemFilled": {
          "addVariables": "変数を追加する",
          "descriptionNoVariables": "テンプレートに動的なデータを追加するには、変数を使用します。\n\nこの時点で、データ ソースとレコードの種類を選択します。後からテンプレートを使用するユーザーが、使用するレコードの種類を選択します。",
          "descriptionWithVariables": "テンプレートに動的なデータを追加するには、変数を使用します。",
          "dropdownDescription": "各変数からデータを追加します",
          "manageVariables": "変数を管理する",
          "searchData": "データを検索",
          "title": "システムが入力済み",
          "toolTip": "システムが入力したフィールド",
          "variable": "変数"
        }
      },
      "maxFileSizeLimitMessage": "The maximum file size supported is 20 MB",
      "multiLineLabel": "複数行を許可する",
      "name": "名前",
      "noSignerComponentInfoModal": {
        "cancelButtonText": "戻る",
        "confirmButtonText": "このまま続行する",
        "description": "このまま続行して次の手順に進めますが、戻って記入用のフィールドを追加することもできます。",
        "subtitle": "これらの役割には署名するものが何もありません:",
        "title": "フィールドを忘れていませんか?"
      },
      "optionsLabel": "オプション",
      "paymentAmountInvalidError": "続行するには支払い額を入力してください",
      "personalFolders": "個人用フォルダー",
      "preparePage": {
        "footerButton": "次の手順"
      },
      "previous": "戻る",
      "radio": "ラジオ ボタン グループ",
      "readyState": "準備完了",
      "reasonDeclineLabel": "拒否の理由",
      "reasonVoidLabel": "取り消しの理由",
      "recipientListHeading": "このテンプレートに必要な役割",
      "recipientName": "名前",
      "recipientRemindButtonLabel": "通知",
      "recipientRole": "役割",
      "recipientRoleSigner": "署名者",
      "recipientRoleViewer": "閲覧者",
      "recipientStatusSigned": "署名済み",
      "recipientUniqueEmailErrorMessage": "受信者のメール アドレスには一意のものが必要です。",
      "recipientUnlockLabel": "ロック解除",
      "recipientsLabel": "受信者",
      "recordType": "レコードの種類",
      "referenceIdLabel": "参照 ID",
      "reminderSent": "通知を送信しました",
      "removeFieldLabel": "フィールドの削除",
      "requiredFieldLabel": "必須フィールド",
      "reviewAndSave": "確認して保存する",
      "reviewPage": {
        "descriptionPlaceholderText": "説明文を入力してください",
        "footerButton": "テンプレートを保存する",
        "kbaRequirement": "KBA 要件",
        "kbaTooltip": "署名者は、ナレッジベースに登録された本人確認のための質問に回答する必要があります。署名者ごとに、ドキュメントに署名する前に確認を求められます。",
        "passCodeTooltip": "受信者がドキュメントにアクセスするには、5 桁のパスコードを入力する必要があります。",
        "passcodeLabel": "パスコード",
        "securityOptionsLabel": "セキュリティのオプション",
        "templateNameBlank": "テンプレート名を入力する",
        "templatePlaceholderText": "テンプレート名を入力してください"
      },
      "roleNameUniqueError": "役割名は一意の名前にする必要があります",
      "roleNameValidationError": "役割名は英数字にする必要があります",
      "save": "保存",
      "selectOneOrMoreLabel": "1 つ以上選択",
      "selectOnlyOneLabel": "1 つのみ選択",
      "selfSignature": "自分の署名",
      "sendAgreement": {
        "assignRequestBody": "契約書に署名したユーザーを、エンゲージメントのすべてのクライアント リクエストに割り当てます",
        "assignRequestTitle": "契約書に署名したユーザーにリクエストを割り当てます",
        "changeTemplate": "テンプレートを変更する",
        "document": "ドキュメント",
        "eSignaturePermissionErrorMessage": "署名へのアクセス権がありません。アクセス権が必要な場合は、管理者にお問い合わせください。",
        "nextTemplate": "次へ: テンプレートを選択する",
        "selectTemplateTitle": "テンプレートを選択する",
        "selectedAgreementTemplate": "選択した契約テンプレート",
        "selectedClient": "選択したクライアント",
        "shareRequestBody": "割り当てられたリクエストを共有する",
        "shareRequestTitle": "リクエストを共有する",
        "signatureDescription": "契約書に署名し完了した場合",
        "stepsTitle": "契約書の送信ワークフロー手順",
        "title": "契約を送信する"
      },
      "setSigningOrder": "署名の順番を設定",
      "setToDateOfExecution": "実行日に設定する",
      "shareFileFolder": {
        "selectShareFileFolder": {
          "cancelButtonLabel": "キャンセル",
          "createFolderLabel": "フォルダーの作成",
          "disabledNodeAdminReason": "このフォルダーを選択するには管理者の権限が必要です",
          "disabledSharedFoldersReason": "最上位の共有フォルダーを選択できません",
          "modalTitle": "署名済みドキュメントの保存場所",
          "selectFolderButtonLabel": "フォルダーを選択する"
        }
      },
      "sharedFolders": "共有フォルダー",
      "signature": "署名",
      "signatureAnnotationMessage": "クリックおよびドラッグしてボックスに署名を手書き入力",
      "signatureAnnotationTextMessage": "以下のフィールドに署名を入力してください",
      "signatureRequest": {
        "closeDrawerModalContent": "今このリクエストを閉じると、作業中の内容が失われ、最初からやり直す必要があります。",
        "closeDrawerModalTitle": "署名リクエストを破棄する"
      },
      "signatureRequestErrorMessage": "署名リクエストに失敗しました",
      "signerDescription": "役割ごとにフィールドを配置します",
      "signers": "署名者",
      "startPage": {
        "addAnotherRole": "別の役割を追加する",
        "addNewRole": "新しい役割を追加する",
        "deleteButtonAriaLabel": "役割 {{roleName}} を削除する",
        "dragRoleAriaLabel": "役割 {{roleName}} をドラッグする",
        "footerButton": "次の手順: フィールドの配置",
        "navigateAwayDialog": {
          "continue": "続行",
          "dontShowAgain": "このメッセージを再度表示しない",
          "moveAwaySelections": "現在のフォルダーから移動すると、選択内容は失われます。"
        },
        "roleDescription": "ドキュメントに署名する各ユーザーの役割を作成します。このテンプレートを使用するときは、各役割のメール アドレスを指定します",
        "roleLabel": "署名者の役割",
        "roleName": "役割名",
        "sequenceInputAriaLabel": "役割 {{roleName}} のシーケンスを入力してください",
        "setSignerSequence": "署名者シーケンスを設定する"
      },
      "started_onboarding_agreement_flow": "オンボード契約フローを開始しました",
      "templateCreationNotificationMessage": "{<templateName>} テンプレートを作成しました",
      "text": "文字列",
      "textAlignLabel": "テキストの位置を揃える",
      "type": "種類",
      "unknown": "不明",
      "uploadDocumentErrorMessage": "ドキュメントをアップロードして次の手順に進む",
      "uploadDocxFileModal": {
        "fileTypeErrorNotification": "Only DOCX files are supported",
        "okButtonText": "Create template",
        "title": "Upload DOCX file",
        "uploadTypes": {
          "computer": {
            "browse": "browse",
            "dragFilesHereOr": "Drag files here or"
          },
          "sharefile": "From ShareFile"
        }
      },
      "variableNameValidationError": "変数名は英数字にする必要があります",
      "variables": {
        "addAnotherVariable": "別の変数を追加する",
        "addNewVariable": "新しい変数を追加する",
        "dataSource": "データ ソース",
        "deleteButtonAriaLabel": "変数 {{variableName}} を削除する",
        "description": "テンプレートで変数を使用すると、情報が自動的に入力されます。データの種類とデータ ソースを選択できます。テンプレートを使用する場合、送信者は使用するデータを指定します。",
        "errorMessages": {
          "invalidDataSource": "各変数にはデータ ソースが必要です",
          "invalidName": "各変数に名前が必要です",
          "invalidSourceRecord": "各変数にソース レコードが必要です",
          "uniqueName": "変数名は一意の名前にする必要があります"
        },
        "fieldsAssignedWarningHeader": "変数に割り当てられたフィールド",
        "fieldsAssignedWarningMessage": "変数に割り当てられたすべてのフィールドが削除されます。",
        "label": "変数",
        "missingDatasourceIntegration": {
          "addIntegrationBody": "次の場所に移動: アカウント > 接続 > 新しい接続を追加。",
          "addIntegrationHeader": "新しい統合を追加するには",
          "message": "現時点では、お使いのアカウントにはサードパーティとの接続がありません。\n"
        },
        "sourceRecord": "ソース レコード",
        "variableName": "変数名"
      },
      "zoomIn": "拡大",
      "zoomOut": "縮小"
    }
  },
  {
    "key": "nl",
    "content": {
      "PaymentFieldLabel": "Betaling innen",
      "SelectFieldLabel": "Vervolgkeuzelijst",
      "SendSignatureRequest": {
        "addFieldDataPanel": {
          "autofilledToastMessage": "Populated {{numberOfFieldsCompleted}} fields",
          "autofilledToastWarningDescription": "We weren’t able to populate every field. You can still continue to next step",
          "autofilledToastWarningMessage": "Populated {{numberOfFieldsFilled}} out of {{totalNumberOfFields}} fields",
          "editVariableNote": "Once you enter value here, click on Update fields to fill this value in the document",
          "editedField": "Edited",
          "enterFieldValue": "Enter field value",
          "generateDocumentModal": {
            "cancelButtonText": "Cancel",
            "confirmButtonText": "Generate",
            "description": "Are you sure you’re ready to generate this document? Please note that once it’s generated, you won’t be able to make changes to any fields.",
            "title": "Generate document"
          },
          "invalidMailMessage": "Please enter a valid email address",
          "notFilled": "Not filled",
          "pending": "In behandeling",
          "populatingFields": "Populating fields",
          "signersFieldEdited": "You have edited some fields but they are not updated in the document. Click on 'Update fields' before moving on.",
          "trackFieldsLabel": "Track fields linked with {{variableName}} ({{filledFields}}/{{totalFields}}) filled",
          "updateFields": "Update fields",
          "variableNotPresentAtSource": "Variable not present at source"
        },
        "documentNameError": "Voer een documentnaam in",
        "expirationDaysNotificationMessage": "Kies een vervaldatum",
        "footer": {
          "changeTemplate": "Sjabloon wijzigen",
          "generateDocument": "Generate document",
          "sendForSignatureProgressMessage": "Uw document wordt voorbereid. Klik niet op de knop Vernieuwen of Terug",
          "sendRequest": "Send for Signature",
          "startOver": "Start over"
        },
        "generatingAndMergingDocumentText": "Just setting things up from your template — almost there!",
        "noVariableComponentInfoModal": {
          "cancelButtonText": "Terugkeren",
          "confirmButtonText": "Toch doorgaan",
          "description": "Als u doorgaat naar de volgende stap zonder deze variabelen in te vullen, blijven de afhankelijke velden leeg.",
          "subtitle": "De volgende variabelen zijn momenteel leeg:",
          "title": "Bent u vergeten variabelen in te vullen?"
        },
        "populateFields": "Populate fields",
        "rightPanel": {
          "SignerNotePlaceholder": "Opmerking toevoegen voor alle ondertekenaars",
          "days": "dag(en)",
          "documentName": "Documentnaam",
          "downloadDocument": "Document downloaden",
          "edit": "Bewerken",
          "email": "E-mail",
          "emailPlaceholder": "E-mailadres ontvanger invoeren",
          "emptyListMessage": "Terwijl u begint te typen, verschijnen hier overeenkomende variabelewaarden",
          "expiration": "Vervaldatum",
          "expirationDateMessage": "Vervaldatum: {{expirationDate}}",
          "expirationDaysError": "Voer een getal in tussen 1 en 365",
          "expirationDaysLabel": "dag(en)",
          "name": "Naam",
          "namePlaceholder": "Naam ontvanger invoeren",
          "noResults": "Geen resultaten gevonden voor uw zoekopdracht",
          "recipientEmailPlaceholder": "E-mailadres ontvanger invoeren",
          "recipientNamePlaceholder": "Naam ontvanger invoeren",
          "searching": "Zoeken",
          "securityOptions": "Beveiligingsopties",
          "sharefileContactsCallErrorMessage": "Kan waarden van variabelen niet ophalen vanwege een probleem met ShareFile-contacten. Wis de zoekopdracht en probeer het opnieuw",
          "signerNote": "Opmerking voor alle ondertekenaars",
          "storageLocation": "Opslaglocatie voor ondertekend document"
        },
        "securityOptions": {
          "generateNewPasscode": "Nieuwe genereren",
          "kbaAlert": "Ondertekenaars worden na 3 mislukte pogingen buitengesloten uit het document.",
          "kbaDescription": "Vereis dat ontvangers hun identiteit verifiëren via een op kennis gebaseerde quiz. Elke ontvanger moet zich onafhankelijk verifiëren voordat het document wordt ondertekend.",
          "kbaLabel": "Op kennis gebaseerde verificatie",
          "none": "Geen",
          "passcodeAlert": "U moet deze wachtwoordcode delen met elke ontvanger.",
          "passcodeBlankError": "Voer een wachtwoordcode in",
          "passcodeDescription": "Ontvangers moeten een wachtwoordcode van {<fiveDigit>} cijfers invoeren om toegang te krijgen tot de documenten.",
          "passcodeFiveDigit": "van 5 cijfers",
          "passcodeLabel": "Wachtwoordcode",
          "passcodeLengthError": "De wachtwoordcode moet 5 cijfers bevatten",
          "passcodeOnlyDigits": "De wachtwoordcode mag alleen cijfers bevatten.",
          "passcodePlaceholder": "Wachtwoordcode invoeren of genereren",
          "save": "Opslaan",
          "title": "Beveiligingsopties"
        },
        "signatureRequestFailureMessage": "Kan handtekeningaanvraag niet verzenden",
        "signatureRequestSuccessNotification": {
          "message": "Sent signature request",
          "viewButton": "View request"
        },
        "tag": "Sjabloon",
        "title": "Handtekeningaanvraag",
        "variables": {
          "description": "Selecteer een waarde voor elke variabele om gegevens automatisch in te vullen in de volgende stap",
          "noVariablesSelectedError": "Selecteer alle variabelen.",
          "placeholder": "Typ om de overeenkomende variabele te vinden",
          "salesforceIntegrationErrorMsg": "Kan waarden van variabelen niet ophalen vanwege een Salesforce-integratieprobleem. Controleer de integratie-instellingen",
          "subTitle": "Choose variable",
          "title": "Populate fields"
        },
        "viewRequest": "View request"
      },
      "SignatureFieldLabel": "Handtekening",
      "TextFieldLabel": "Tekst",
      "add": "Toevoegen",
      "addCheckbox": "Selectievakje toevoegen",
      "addFilesFromSharefile": "Items toevoegen uit ShareFile",
      "addMyself": "Afzender toevoegen als rol",
      "addOptionLabel": "Optie toevoegen",
      "addRole": "Nog een rol toevoegen",
      "addSignature": "Handtekening toevoegen",
      "annotator": "U (nu)",
      "annotatorOptionTooltip": "Velden vooraf invullen",
      "apply": "Toepassen",
      "assignedToLabel": "Toegewezen aan",
      "cancel": "Annuleren",
      "checkbox": "Selectievakje",
      "checkboxGroup": "Groep selectievakjes",
      "checkboxes": "Selectievakjes",
      "clear": "Wissen",
      "close": "Sluiten",
      "components": {
        "attachment": "Bijlage",
        "editor": {
          "defaultHelpText": "Upload hier uw bijlage",
          "fontSizeLabel": "Lettertypegrootte",
          "helpTextLabel": "Helptekst toevoegen"
        }
      },
      "confirm": "Bevestigen",
      "createDocumentTemplateModal": {
        "description": "Create a template to generate PDF documents and send them for e-signature",
        "features": {
          "addFields": "Add fields such as text, date, or signature for signers to fill out",
          "systemFilledData": "Optionally use data from your system to automatically fill the fields"
        },
        "templates": {
          "dynamic": {
            "description": "A reusable template, generated from a PDF or DOCX file. {<lineBreak>} Ideal if the file won’t change often—great for standard forms and contracts."
          },
          "editableWord": {
            "alertMessage": "You'll need to install ShareFile's Word add-in",
            "description": "A reusable template, directly editable in Microsoft Word using ShareFile's Word add-in. {<lineBreak>} Best for templates that need frequent content updates."
          },
          "title": "Select template type"
        },
        "title": "Create document template"
      },
      "createdTemplateSuccess": "Documentsjabloon gemaakt",
      "dashboard": {
        "card": {
          "createdBy": "Gemaakt door"
        },
        "createTemplateButton": "Nieuw documentsjabloon",
        "loading": "Laden...",
        "title": "Sjablonen"
      },
      "date": "Datum",
      "dateExample": "Voorbeeld:",
      "dateFormatLabel": "Notatie",
      "dateSignedLabel": "Datum van automatisch invullen ondertekend",
      "dateSignedTooltip": "Een ontvanger kan het veld niet bewerken. Het wordt automatisch ingevuld op de dag dat het document wordt ondertekend.",
      "defaultValueLabel": "Standaardtekst toevoegen",
      "deleteConfirmationModal": {
        "cancelButton": "Cancel",
        "cancelButtonText": "Doorgaan met bewerken",
        "confirmButtonText": "Verwijderen",
        "okButtonText": "Ok"
      },
      "deleteDetails": {
        "deleteConfirmation": {
          "content": "Are you sure you want to delete the {<templateName>} template? The template will be permanently deleted. If this template is shared, users will lose access",
          "title": "Delete template"
        },
        "notification": {
          "successMessage": "Template deleted successfully"
        }
      },
      "description": "Beschrijving",
      "details": {
        "actionItems": {
          "addToMyTemplates": "Toevoegen aan mijn sjablonen",
          "delete": "Delete template",
          "download": "Downloaden",
          "edit": "Bewerken",
          "sendAsSignatureRequest": "Verzenden als handtekeningaanvraag",
          "share": "Delen",
          "useAsDocument": "Als document gebruiken"
        },
        "documentTemplate": "documentsjabloon",
        "overview": {
          "createdBy": "Gemaakt door",
          "cretedOn": "Gemaakt op",
          "description": "Beschrijving",
          "doc": "DOC",
          "edit": "Bewerken",
          "pdf": "PDF",
          "tabs": {
            "fields": "Velden",
            "overview": "Overzicht"
          }
        },
        "settings": {
          "disabled": "Uitgeschakeld",
          "enabled": "Ingeschakeld",
          "kbaRequirement": "KBA-vereiste",
          "passcode": "Wachtwoordcode",
          "title": "Instellingen toegepast"
        },
        "shareTemplateSuccess": "Documentsjabloon gedeeld",
        "title": "Documentsjabloon"
      },
      "discardTemplate": {
        "cancelButtonText": "Doorgaan met bewerken",
        "confirmButtonText": "Verwijderen",
        "content": "Als u dit nu afsluit, verliest u uw voortgang en moet u opnieuw beginnen",
        "title": "Sjabloon verwijderen"
      },
      "docTemplateListing": {
        "button": "Maken",
        "emptyState": {
          "button": "Sjabloon maken",
          "subtitle": "Begin met het gebruik van sjablonen om te voorkomen dat documenten opnieuw worden gemaakt",
          "title": "Eerste documentsjabloon maken"
        },
        "noSearchResults": {
          "subtitle": "We kunnen {<searchTerm>} in geen enkele sjabloontitel of -beschrijving vinden.",
          "title": "Uw zoekopdracht komt met geen enkele sjabloon overeen"
        }
      },
      "documentThumbnailAltText": "Geen miniatuur beschikbaar",
      "documentToSend": "Document selecteren",
      "documentView": {
        "documentPageIndex": "Pagina {<currentPage>} van {{totalPages}}",
        "pageChangeInputLabel": "Pagina wijzigen in",
        "pageDown": "Volgende pagina",
        "pageUp": "Vorige pagina"
      },
      "draw": "Tekenen",
      "dropdownInsufficientOptionsError": "Elk vervolgkeuzemenu moet minimaal 2 opties hebben",
      "edit": {
        "cancelText": "Cancel",
        "checkedOutInfo": "We can’t rename, move, or delete files while they’re being edited. We also can’t upload files that have the same name.",
        "checkedOutTitle": "This file is being edited",
        "closeText": "Close",
        "edit": "Edit",
        "editDesktopConfirmMessage": "Make sure you're signed in to ShareFile.",
        "editDesktopOpenMessage": " should have opened in Microsoft {{appType}} on your desktop application.",
        "editDesktopTitle": "Create in Microsoft {{appType}}",
        "editDesktopWarning": "If you don't have Microsoft Word, you can still ",
        "editError": "Error occurred while initializing Edit session. Please try again.",
        "editInMicrosoftWord": "Edit in Microsoft Word",
        "editOnline": "Edit online",
        "editOnlineLearnText": "Learn more about editing online.",
        "editOnlineOpenMessage": " should have opened in Microsoft {{appType}} Online in a new tab.",
        "editOnlineText": "edit online.",
        "editOnlineTitle": "Edit Online",
        "editTroubleText": "Having trouble? ",
        "learnMoreText": "Learn more.",
        "signInCheckboxText": "I've signed in to ShareFile",
        "signInMessage": "Before you can open files in Microsoft {{appType}}, you need to sign in to ShareFile. You'll only need to do this once. ",
        "signInPostScriptText": "After you sign in, come back to this page to open the document.",
        "signInSharefileTitle": "Sign in to ShareFile",
        "signInText": "Sign In",
        "tryAgainText": "Try Again"
      },
      "emptyFolder": "Deze map is leeg",
      "emptyRoleName": "Dit veld is verplicht",
      "errorMessages": {
        "createDocumentError": "Kan document niet maken",
        "createDocumentTemplateError": "Kan documentsjabloon niet maken",
        "deleteUploadedFileError": "Kan bestand niet verwijderen",
        "fetchDataSourcesError": "Kan gegevensbron niet ophalen",
        "fetchEntitiesError": "Kan entiteiten niet ophalen",
        "fetchFileError": "Failed to download file",
        "fetchPdfFileError": "Kan pdf-bestand niet downloaden",
        "fetchSchemaError": "Kan schema niet ophalen",
        "fetchThumbnailUrlError": "Kan miniatuur niet ophalen",
        "generateDocumentError": "Failed to generate document",
        "getDocumentError": "Kan document niet ophalen",
        "getDocumentTemplateError": "Kan documentsjabloon niet ophalen",
        "getTemplatesError": "Kan sjablonen niet ophalen",
        "saveVariablesError": "Kan variabele niet opslaan",
        "updateDocumentError": "Kan document niet opslaan",
        "updateDocumentTemplateError": "Kan sjabloon niet opslaan",
        "uploadFileError": "Kan bestand niet uploaden"
      },
      "extensionSlots": {
        "createNewTemplate": "Nieuw documentsjabloon",
        "dashboardShortcut": "Nieuw documentsjabloon maken",
        "templates": "Sjablonen"
      },
      "favorites": "Favorieten",
      "fieldNameLabel": "Veldnaam",
      "fieldRequired": "Dit veld is verplicht",
      "fields": "Velden",
      "fieldsAssignedWarningHeader": "Velden die zijn toegewezen aan rollen",
      "fieldsAssignedWarningMessage": "Alle velden die aan de rol(len) zijn toegewezen, worden verwijderd.",
      "fileNotSupportedTooltip": "Niet-ondersteunde bestandsindeling",
      "footer": {
        "previousButton": "Vorige stap"
      },
      "genericError": "Er is iets fout gegaan. Probeer het opnieuw",
      "groupNameLabel": "Groep een naam geven",
      "groupRule": "Groepsregel",
      "hasAtleastOneRoleErrorMessage": "Voeg minstens één rol toe om door te gaan",
      "header": {
        "stepper": {
          "stepOne": "Sjabloon voorbereiden",
          "stepThree": "Controleren en opslaan",
          "stepTwo": "Velden toevoegen"
        },
        "title": "Sjabloon maken"
      },
      "initials": "Initialen",
      "invalidDocgenRequest": "Handtekeningaanvraag lijkt ongeldig. Controleer de URL",
      "invalidEmail": "Ongeldige e-mail",
      "invalidRecipientErrorMessage": "We hebben een naam en e-mail nodig voor elke ontvanger",
      "invalidRoleErrorMessage": "We hebben een naam nodig voor elke rol",
      "label": "Label",
      "leftNav": {
        "annotateDescription": "Gebruik deze velden om labels, selectievakjes of andere soorten aantekeningen aan uw PDF-documenten toe te voegen.",
        "annotateDocument": "Maak aantekeningen van het document",
        "senderFields": "Velden ingevuld door afzender",
        "signerFields": "Velden ingevuld door ondertekenaar",
        "signerFilled": {
          "addRoles": "Rollen toevoegen",
          "descriptionNoRoles": "Maak een rol voor elke persoon die aan het documentproces zal deelnemen. (indien van toepassing)\n\nIn een juridisch contract kunt u bijvoorbeeld rollen creëren voor 'Cliënt', 'Advocaat' en 'Getuige'.\n\nWanneer iemand uw sjabloon gebruikt, wijst hij eenvoudigweg e-mailadressen toe aan elke rol. Dit zorgt ervoor dat iedereen de juiste versie van het document krijgt en stroomlijnt het ondertekeningsproces",
          "descriptionWithRoles": "Voeg velden toe die moeten worden ingevuld door gebruikers die dit sjabloon ontvangen",
          "dropdownDescription": "U voegt velden toe voor de rol {{roleName}}",
          "manageRoles": "Rollen beheren",
          "role": "Rol",
          "title": "Ingevuld door ondertekenaar"
        },
        "systemFilled": {
          "addVariables": "Variabelen toevoegen",
          "descriptionNoVariables": "Gebruik variabelen om dynamische gegevens aan uw sjabloon toe te voegen.\n\nOp dit punt selecteert u de gegevensbron en het recordtype. Wanneer iemand later de sjabloon gebruikt, zal deze kiezen welk recordtype deze wil gebruiken.",
          "descriptionWithVariables": "Gebruik variabelen om dynamische gegevens aan uw sjabloon toe te voegen.",
          "dropdownDescription": "U voegt gegevens uit elke variabele toe",
          "manageVariables": "Variabelen beheren",
          "searchData": "Gegevens zoeken",
          "title": "Ingevuld door systeem",
          "toolTip": "Velden ingevuld door systeem",
          "variable": "Variabel"
        }
      },
      "maxFileSizeLimitMessage": "The maximum file size supported is 20 MB",
      "multiLineLabel": "Meerdere regels toestaan",
      "name": "Naam",
      "noSignerComponentInfoModal": {
        "cancelButtonText": "Terugkeren",
        "confirmButtonText": "Toch doorgaan",
        "description": "U kunt toch doorgaan naar de volgende stap, of u kunt terugkeren en velden toevoegen om in te vullen.",
        "subtitle": "Deze rollen hebben niets te ondertekenen:",
        "title": "Bent u velden vergeten?"
      },
      "optionsLabel": "Opties",
      "paymentAmountInvalidError": "Voer een betalingsbedrag in om door te gaan",
      "personalFolders": "Persoonlijke mappen",
      "preparePage": {
        "footerButton": "Volgende stap"
      },
      "previous": "Vorige",
      "radio": "Groep keuzerondjes",
      "readyState": "Klaar!",
      "reasonDeclineLabel": "Reden voor afwijzing",
      "reasonVoidLabel": "Reden voor ongeldig maken",
      "recipientListHeading": "Welke rollen heeft deze sjabloon nodig?",
      "recipientName": "Naam",
      "recipientRemindButtonLabel": "Herinneren",
      "recipientRole": "Rol",
      "recipientRoleSigner": "Ondertekenaar",
      "recipientRoleViewer": "Waarnemer",
      "recipientStatusSigned": "Ondertekend",
      "recipientUniqueEmailErrorMessage": "Het e-mailadres van de ontvanger moet uniek zijn.",
      "recipientUnlockLabel": "Ontgrendelen",
      "recipientsLabel": "Ontvangers",
      "recordType": "Soort gegevens",
      "referenceIdLabel": "Referentie-id",
      "reminderSent": "Herinnering verzonden",
      "removeFieldLabel": "Veld verwijderen",
      "requiredFieldLabel": "Verplicht veld",
      "reviewAndSave": "Controleren en opslaan",
      "reviewPage": {
        "descriptionPlaceholderText": "Voer beschrijving in",
        "footerButton": "Sjabloon opslaan",
        "kbaRequirement": "KBA-vereiste",
        "kbaTooltip": "Vereis dat ondertekenaars hun identiteit verifiëren via een op kennis gebaseerde quiz. Elke ondertekenaar moet zich onafhankelijk verifiëren voordat het document wordt ondertekend.",
        "passCodeTooltip": "Ontvangers moeten een wachtwoordcode van 5 cijfers invoeren om toegang te krijgen tot de documenten.",
        "passcodeLabel": "Wachtwoordcode",
        "securityOptionsLabel": "Beveiligingsopties",
        "templateNameBlank": "Voer een sjabloonnaam in",
        "templatePlaceholderText": "Voer sjabloonnaam in"
      },
      "roleNameUniqueError": "De rolnaam moet uniek zijn",
      "roleNameValidationError": "De rolnaam moet alfanumeriek zijn",
      "save": "Opslaan",
      "selectOneOrMoreLabel": "Selecteer één of meer",
      "selectOnlyOneLabel": "Selecteer slechts één",
      "selfSignature": "Uw handtekening",
      "sendAgreement": {
        "assignRequestBody": "Wijs de gebruiker die de overeenkomst heeft ondertekend toe aan alle klantaanvragen van de opdracht",
        "assignRequestTitle": "Wijs de aanvraag toe aan de gebruiker die de overeenkomst heeft ondertekend",
        "changeTemplate": "Sjabloon wijzigen",
        "document": "document",
        "eSignaturePermissionErrorMessage": "U hebt geen toegang tot handtekeningen. Neem contact op met uw beheerder als u toegang nodig hebt.",
        "nextTemplate": "Volgende: Sjabloon selecteren",
        "selectTemplateTitle": "Sjabloon selecteren",
        "selectedAgreementTemplate": "Geselecteerde overeenkomstsjabloon",
        "selectedClient": "Geselecteerde klant",
        "shareRequestBody": "De toegewezen aanvraag delen",
        "shareRequestTitle": "De aanvraag delen",
        "signatureDescription": "Wanneer de overeenkomst is ondertekend en voltooid",
        "stepsTitle": "Werkstroomstappen voor het verzenden van overeenkomsten",
        "title": "Overeenkomst verzenden"
      },
      "setSigningOrder": "Ondertekeningsvolgorde instellen",
      "setToDateOfExecution": "Instellen op datum van uitvoering",
      "shareFileFolder": {
        "selectShareFileFolder": {
          "cancelButtonLabel": "Annuleren",
          "createFolderLabel": "Map maken",
          "disabledNodeAdminReason": "Beheerdertoestemming is nodig om deze map te selecteren",
          "disabledSharedFoldersReason": "Kan gedeelde mappen op het hoogste niveau niet selecteren",
          "modalTitle": "Opslaglocatie voor ondertekend document",
          "selectFolderButtonLabel": "Map selecteren"
        }
      },
      "sharedFolders": "Gedeelde mappen",
      "signature": "Handtekening",
      "signatureAnnotationMessage": "Klik en sleep om uw handtekening in het vak te zetten",
      "signatureAnnotationTextMessage": "Typ uw handtekening in het onderstaande veld",
      "signatureRequest": {
        "closeDrawerModalContent": "Als u deze aanvraag nu sluit, verliest u uw voortgang en moet u opnieuw beginnen",
        "closeDrawerModalTitle": "Handtekeningaanvraag verwijderen"
      },
      "signatureRequestErrorMessage": "Handtekeningaanvraag mislukt",
      "signerDescription": "U plaatst velden voor elke rol",
      "signers": "Ondertekenaars",
      "startPage": {
        "addAnotherRole": "Nog een rol toevoegen",
        "addNewRole": "Nieuwe rol toevoegen",
        "deleteButtonAriaLabel": "Verwijder rol {{roleName}}",
        "dragRoleAriaLabel": "Sleep rol {{roleName}}",
        "footerButton": "Volgende stap: Velden plaatsen",
        "navigateAwayDialog": {
          "continue": "Doorgaan",
          "dontShowAgain": "Dit bericht niet meer weergeven",
          "moveAwaySelections": "Als u uw huidige map verlaat, gaan uw selecties verloren."
        },
        "roleDescription": "Maak een rol voor elke persoon die het document zal ondertekenen. Wanneer iemand deze sjabloon gebruikt, geeft hij of zij voor elke rol een e-mailadres op.",
        "roleLabel": "Rollen van ondertekenaars",
        "roleName": "Naam van de rol",
        "sequenceInputAriaLabel": "Voer volgorde in voor rol {{roleName}}",
        "setSignerSequence": "Stel de volgorde van ondertekenaars in"
      },
      "started_onboarding_agreement_flow": "Gestart met de onboarding-overeenkomststroom",
      "templateCreationNotificationMessage": "Sjabloon <templateName> gemaakt",
      "text": "Tekst",
      "textAlignLabel": "Tekst uitlijnen",
      "type": "Type",
      "unknown": "Onbekend",
      "uploadDocumentErrorMessage": "Upload een document om naar de volgende stap te gaan",
      "uploadDocxFileModal": {
        "fileTypeErrorNotification": "Only DOCX files are supported",
        "okButtonText": "Create template",
        "title": "Upload DOCX file",
        "uploadTypes": {
          "computer": {
            "browse": "browse",
            "dragFilesHereOr": "Drag files here or"
          },
          "sharefile": "From ShareFile"
        }
      },
      "variableNameValidationError": "De naam van de variabele moet alfanumeriek zijn",
      "variables": {
        "addAnotherVariable": "Nog een variabele toevoegen",
        "addNewVariable": "Een nieuwe variabele toevoegen",
        "dataSource": "Gegevensbron",
        "deleteButtonAriaLabel": "Verwijder variabele {{variableName}}",
        "description": "Gebruik variabelen in uw sjabloon, zodat informatie automatisch kan worden ingevuld. U kunt het gegevenstype en de gegevensbron selecteren. Bij gebruik van het sjabloon geeft de afzender aan welke gegevens moeten worden geselecteerd.",
        "errorMessages": {
          "invalidDataSource": "We hebben voor elke variabele een gegevensbron nodig",
          "invalidName": "We hebben een naam nodig voor elke variabele",
          "invalidSourceRecord": "We hebben voor elke variabele een gegevensbron nodig",
          "uniqueName": "De naam van de variabele moet uniek zijn"
        },
        "fieldsAssignedWarningHeader": "Velden die zijn toegewezen aan variabele",
        "fieldsAssignedWarningMessage": "Alle velden die aan de variabele zijn toegewezen, worden verwijderd.",
        "label": "Variabel",
        "missingDatasourceIntegration": {
          "addIntegrationBody": "Ga naar: Account > Verbindingen > Nieuwe verbinding toevoegen.",
          "addIntegrationHeader": "Om een nieuwe integratie toe te voegen",
          "message": "Uw account heeft op dit moment geen verbindingen van derden.\n"
        },
        "sourceRecord": "Gegevensbron",
        "variableName": "Naam van de variabele"
      },
      "zoomIn": "Inzoomen",
      "zoomOut": "Uitzoomen"
    }
  },
  {
    "key": "pt-BR",
    "content": {
      "PaymentFieldLabel": "Receber pagamento",
      "SelectFieldLabel": "Menu suspenso",
      "SendSignatureRequest": {
        "addFieldDataPanel": {
          "autofilledToastMessage": "Populated {{numberOfFieldsCompleted}} fields",
          "autofilledToastWarningDescription": "We weren’t able to populate every field. You can still continue to next step",
          "autofilledToastWarningMessage": "Populated {{numberOfFieldsFilled}} out of {{totalNumberOfFields}} fields",
          "editVariableNote": "Once you enter value here, click on Update fields to fill this value in the document",
          "editedField": "Edited",
          "enterFieldValue": "Enter field value",
          "generateDocumentModal": {
            "cancelButtonText": "Cancel",
            "confirmButtonText": "Generate",
            "description": "Are you sure you’re ready to generate this document? Please note that once it’s generated, you won’t be able to make changes to any fields.",
            "title": "Generate document"
          },
          "invalidMailMessage": "Please enter a valid email address",
          "notFilled": "Not filled",
          "pending": "Pendente",
          "populatingFields": "Populating fields",
          "signersFieldEdited": "You have edited some fields but they are not updated in the document. Click on 'Update fields' before moving on.",
          "trackFieldsLabel": "Track fields linked with {{variableName}} ({{filledFields}}/{{totalFields}}) filled",
          "updateFields": "Update fields",
          "variableNotPresentAtSource": "Variable not present at source"
        },
        "documentNameError": "Insira um nome de documento",
        "expirationDaysNotificationMessage": "Escolha uma data de vencimento",
        "footer": {
          "changeTemplate": "Alterar modelo",
          "generateDocument": "Generate document",
          "sendForSignatureProgressMessage": "Preparando seu documento. Não clique no botão Atualizar ou Voltar",
          "sendRequest": "Send for Signature",
          "startOver": "Start over"
        },
        "generatingAndMergingDocumentText": "Just setting things up from your template — almost there!",
        "noVariableComponentInfoModal": {
          "cancelButtonText": "Voltar",
          "confirmButtonText": "Continuar mesmo assim",
          "description": "Se você prosseguir para a próxima etapa sem preencher essas variáveis, os campos dependentes permanecerão vazios.",
          "subtitle": "As seguintes variáveis estão vazias no momento:",
          "title": "Você esqueceu de preencher alguma variável?"
        },
        "populateFields": "Populate fields",
        "rightPanel": {
          "SignerNotePlaceholder": "Adicionar nota a todos os signatários",
          "days": "dia(s)",
          "documentName": "Nome do documento",
          "downloadDocument": "Baixar documento",
          "edit": "Editar",
          "email": "Email",
          "emailPlaceholder": "Insira o email do destinatário",
          "emptyListMessage": "Quando você começar a digitar, os valores das variáveis correspondentes aparecerão aqui",
          "expiration": "Expiração",
          "expirationDateMessage": "Data de expiração: {{expirationDate}}",
          "expirationDaysError": "Insira um número entre 1 e 365",
          "expirationDaysLabel": "dia(s)",
          "name": "Nome",
          "namePlaceholder": "Insira o nome do destinatário",
          "noResults": "Nenhum resultado encontrado para sua pesquisa",
          "recipientEmailPlaceholder": "Insira o email do destinatário",
          "recipientNamePlaceholder": "Insira o nome do destinatário",
          "searching": "Pesquisando",
          "securityOptions": "Opções de segurança",
          "sharefileContactsCallErrorMessage": "Não é possível obter valores de variáveis devido a algum problema com os contatos do ShareFile. Limpe a pesquisa e tente novamente",
          "signerNote": "Nota para todos os signatários",
          "storageLocation": "Local de armazenamento do documento assinado"
        },
        "securityOptions": {
          "generateNewPasscode": "Gerar novo",
          "kbaAlert": "Os signatários serão bloqueados no documento após 3 tentativas incorretas.",
          "kbaDescription": "Exija que os destinatários verifiquem sua identidade com um questionário baseado em conhecimento. Cada signatário precisará verificar de forma independente antes de assinar o documento.",
          "kbaLabel": "Autenticação baseada em conhecimento",
          "none": "Nenhuma",
          "passcodeAlert": "Você precisará compartilhar esse código secreto com cada destinatário.",
          "passcodeBlankError": "Insira o código secreto",
          "passcodeDescription": "Os destinatários devem inserir um código secreto de {<fiveDigit>} dígitos para ter acesso aos documentos.",
          "passcodeFiveDigit": "5 dígitos",
          "passcodeLabel": "Código secreto",
          "passcodeLengthError": "O código secreto deve ter 5 dígitos",
          "passcodeOnlyDigits": "O código secreto só pode conter dígitos.",
          "passcodePlaceholder": "Insira ou gere a senha",
          "save": "Salvar",
          "title": "Opções de segurança"
        },
        "signatureRequestFailureMessage": "Falha ao enviar a solicitação de assinatura",
        "signatureRequestSuccessNotification": {
          "message": "Sent signature request",
          "viewButton": "View request"
        },
        "tag": "Modelo",
        "title": "Solicitação de assinatura",
        "variables": {
          "description": "Selecione um valor para cada variável para preencher automaticamente os dados na próxima etapa",
          "noVariablesSelectedError": "Selecione todas as variáveis.",
          "placeholder": "Digite para encontrar a variável correspondente",
          "salesforceIntegrationErrorMsg": "Não é possível obter valores de variáveis devido a um problema de integração do Salesforce. Verifique as configurações de integração",
          "subTitle": "Choose variable",
          "title": "Populate fields"
        },
        "viewRequest": "View request"
      },
      "SignatureFieldLabel": "Assinatura",
      "TextFieldLabel": "Texto",
      "add": "Adicionar",
      "addCheckbox": "Adicionar caixa de seleção",
      "addFilesFromSharefile": "Adicionar itens do ShareFile",
      "addMyself": "Adicionar remetente como função",
      "addOptionLabel": "Adicionar opção",
      "addRole": "Adicionar outra função",
      "addSignature": "Adicionar assinatura",
      "annotator": "Você (agora)",
      "annotatorOptionTooltip": "Preencha os campos com antecedência",
      "apply": "Aplicar",
      "assignedToLabel": "Atribuído a",
      "cancel": "Cancelar",
      "checkbox": "Caixa de seleção",
      "checkboxGroup": "Grupo de caixas de seleção",
      "checkboxes": "Caixas de seleção",
      "clear": "Apagar",
      "close": "Fechar",
      "components": {
        "attachment": "Anexo",
        "editor": {
          "defaultHelpText": "Carregue seu anexo aqui",
          "fontSizeLabel": "Tamanho da fonte",
          "helpTextLabel": "Adicionar texto de ajuda"
        }
      },
      "confirm": "Confirmar",
      "createDocumentTemplateModal": {
        "description": "Create a template to generate PDF documents and send them for e-signature",
        "features": {
          "addFields": "Add fields such as text, date, or signature for signers to fill out",
          "systemFilledData": "Optionally use data from your system to automatically fill the fields"
        },
        "templates": {
          "dynamic": {
            "description": "A reusable template, generated from a PDF or DOCX file. {<lineBreak>} Ideal if the file won’t change often—great for standard forms and contracts."
          },
          "editableWord": {
            "alertMessage": "You'll need to install ShareFile's Word add-in",
            "description": "A reusable template, directly editable in Microsoft Word using ShareFile's Word add-in. {<lineBreak>} Best for templates that need frequent content updates."
          },
          "title": "Select template type"
        },
        "title": "Create document template"
      },
      "createdTemplateSuccess": "Modelo de documento criado",
      "dashboard": {
        "card": {
          "createdBy": "Criado por"
        },
        "createTemplateButton": "Novo modelo de documento",
        "loading": "Carregando...",
        "title": "Modelos"
      },
      "date": "Data",
      "dateExample": "Exemplo:",
      "dateFormatLabel": "Formato",
      "dateSignedLabel": "Data de preenchimento automático da assinatura",
      "dateSignedTooltip": "Um destinatário não pode editar o campo. Esse campo será preenchido automaticamente no dia da assinatura do documento.",
      "defaultValueLabel": "Adicionar texto padrão",
      "deleteConfirmationModal": {
        "cancelButton": "Cancel",
        "cancelButtonText": "Continuar editando",
        "confirmButtonText": "Descartar",
        "okButtonText": "Ok"
      },
      "deleteDetails": {
        "deleteConfirmation": {
          "content": "Are you sure you want to delete the {<templateName>} template? The template will be permanently deleted. If this template is shared, users will lose access",
          "title": "Delete template"
        },
        "notification": {
          "successMessage": "Template deleted successfully"
        }
      },
      "description": "Descrição",
      "details": {
        "actionItems": {
          "addToMyTemplates": "Adicionar aos meus modelos",
          "delete": "Delete template",
          "download": "Baixar",
          "edit": "Editar",
          "sendAsSignatureRequest": "Enviar como solicitação de assinatura",
          "share": "Compartilhar",
          "useAsDocument": "Usar como documento"
        },
        "documentTemplate": "modelo de documento",
        "overview": {
          "createdBy": "Criado por",
          "cretedOn": "Criado em",
          "description": "Descrição",
          "doc": "DOC",
          "edit": "Editar",
          "pdf": "PDF",
          "tabs": {
            "fields": "Campos",
            "overview": "Visão geral"
          }
        },
        "settings": {
          "disabled": "Desativado",
          "enabled": "Ativado",
          "kbaRequirement": "Requisito de KBA",
          "passcode": "Código secreto",
          "title": "Configurações aplicadas"
        },
        "shareTemplateSuccess": "Modelo de documento compartilhado",
        "title": "Modelo de documento"
      },
      "discardTemplate": {
        "cancelButtonText": "Continuar editando",
        "confirmButtonText": "Descartar",
        "content": "Se você fechar isso agora, perderá seu progresso e terá que começar de novo",
        "title": "Descartar modelo"
      },
      "docTemplateListing": {
        "button": "Criar",
        "emptyState": {
          "button": "Criar modelo",
          "subtitle": "Comece a usar modelos para evitar a recriação de documentos",
          "title": "Criar primeiro modelo de documento"
        },
        "noSearchResults": {
          "subtitle": "Não foi possível encontrar {<searchTerm>} em nenhum título ou descrição de modelo.",
          "title": "Sua pesquisa não corresponde a nenhum modelo"
        }
      },
      "documentThumbnailAltText": "Nenhuma miniatura disponível",
      "documentToSend": "Selecionar documento",
      "documentView": {
        "documentPageIndex": "Página {<currentPage>} de {{totalPages}}",
        "pageChangeInputLabel": "Alterar página para",
        "pageDown": "Próxima página",
        "pageUp": "Página anterior"
      },
      "draw": "Desenhar",
      "dropdownInsufficientOptionsError": "Cada menu suspenso precisa ter pelo menos 2 opções",
      "edit": {
        "cancelText": "Cancel",
        "checkedOutInfo": "We can’t rename, move, or delete files while they’re being edited. We also can’t upload files that have the same name.",
        "checkedOutTitle": "This file is being edited",
        "closeText": "Close",
        "edit": "Edit",
        "editDesktopConfirmMessage": "Make sure you're signed in to ShareFile.",
        "editDesktopOpenMessage": " should have opened in Microsoft {{appType}} on your desktop application.",
        "editDesktopTitle": "Create in Microsoft {{appType}}",
        "editDesktopWarning": "If you don't have Microsoft Word, you can still ",
        "editError": "Error occurred while initializing Edit session. Please try again.",
        "editInMicrosoftWord": "Edit in Microsoft Word",
        "editOnline": "Edit online",
        "editOnlineLearnText": "Learn more about editing online.",
        "editOnlineOpenMessage": " should have opened in Microsoft {{appType}} Online in a new tab.",
        "editOnlineText": "edit online.",
        "editOnlineTitle": "Edit Online",
        "editTroubleText": "Having trouble? ",
        "learnMoreText": "Learn more.",
        "signInCheckboxText": "I've signed in to ShareFile",
        "signInMessage": "Before you can open files in Microsoft {{appType}}, you need to sign in to ShareFile. You'll only need to do this once. ",
        "signInPostScriptText": "After you sign in, come back to this page to open the document.",
        "signInSharefileTitle": "Sign in to ShareFile",
        "signInText": "Sign In",
        "tryAgainText": "Try Again"
      },
      "emptyFolder": "Esta pasta está vazia",
      "emptyRoleName": "Este campo é obrigatório",
      "errorMessages": {
        "createDocumentError": "Falha ao criar documento",
        "createDocumentTemplateError": "Falha ao criar modelo de documento",
        "deleteUploadedFileError": "Falha ao excluir arquivo",
        "fetchDataSourcesError": "Falha ao obter fonte de dados",
        "fetchEntitiesError": "Falha ao obter entidades",
        "fetchFileError": "Failed to download file",
        "fetchPdfFileError": "Falha ao baixar o arquivo PDF",
        "fetchSchemaError": "Falha ao obter esquema",
        "fetchThumbnailUrlError": "Falha ao obter miniatura",
        "generateDocumentError": "Failed to generate document",
        "getDocumentError": "Falha ao obter documento",
        "getDocumentTemplateError": "Falha ao obter modelo de documento",
        "getTemplatesError": "Falha ao obter modelos",
        "saveVariablesError": "Falha ao salvar variável",
        "updateDocumentError": "Falha ao salvar documento",
        "updateDocumentTemplateError": "Falha ao salvar modelo",
        "uploadFileError": "Falha ao carregar arquivo"
      },
      "extensionSlots": {
        "createNewTemplate": "Novo modelo de documento",
        "dashboardShortcut": "Criar modelo de documento",
        "templates": "Modelos"
      },
      "favorites": "Favoritos",
      "fieldNameLabel": "Nome do campo",
      "fieldRequired": "Este campo é obrigatório",
      "fields": "Campos",
      "fieldsAssignedWarningHeader": "Campos atribuídos às funções",
      "fieldsAssignedWarningMessage": "Todos os campos atribuídos à(s) função(ões) serão removidos.",
      "fileNotSupportedTooltip": "Formato de arquivo sem suporte",
      "footer": {
        "previousButton": "Etapa anterior"
      },
      "genericError": "Algo deu errado. Tente novamente",
      "groupNameLabel": "Nomear grupo",
      "groupRule": "Regra do grupo",
      "hasAtleastOneRoleErrorMessage": "Adicione pelo menos uma função para continuar",
      "header": {
        "stepper": {
          "stepOne": "Preparar modelo",
          "stepThree": "Revisar e salvar",
          "stepTwo": "Adicionar campos"
        },
        "title": "Criar modelo"
      },
      "initials": "Iniciais",
      "invalidDocgenRequest": "A solicitação de assinatura parece inválida, verifique o URL",
      "invalidEmail": "Email inválido",
      "invalidRecipientErrorMessage": "Precisamos de um nome e um email para cada destinatário",
      "invalidRoleErrorMessage": "Precisamos de um nome para cada função",
      "label": "Rótulo",
      "leftNav": {
        "annotateDescription": "Use esses campos para adicionar rótulos, caixas de seleção ou outros tipos de anotações aos seus documentos PDF.",
        "annotateDocument": "Anotar documento",
        "senderFields": "Campos preenchidos pelo remetente",
        "signerFields": "Campos preenchidos pelo signatário",
        "signerFilled": {
          "addRoles": "Adicionar funções",
          "descriptionNoRoles": "Defina uma função para cada pessoa que participará do processo de documentação. (se aplicável)\n\nPor exemplo, em um contrato legal, você pode criar funções para “Cliente”, “Advogado” e “Testemunha”.\n\nQuando alguém usa seu modelo, simplesmente atribui endereços de email a cada função. Isso garante que todos obtenham a versão correta do documento e agiliza o processo de assinatura",
          "descriptionWithRoles": "Adicione campos que precisam ser preenchidos pelos usuários que recebem este modelo",
          "dropdownDescription": "Você adicionará campos para a função {{roleName}}",
          "manageRoles": "Gerenciar funções",
          "role": "Função",
          "title": "Preenchido pelo signatário"
        },
        "systemFilled": {
          "addVariables": "Adicionar variáveis",
          "descriptionNoVariables": "Para adicionar dados dinâmicos ao seu modelo, use variáveis.\n\nNeste ponto, você selecionará a fonte de dados e o tipo de registro. Mais tarde, quando alguém usar o modelo, escolherá qual tipo de registro usar.",
          "descriptionWithVariables": "Para adicionar dados dinâmicos ao seu modelo, use variáveis.",
          "dropdownDescription": "Você adicionará dados de cada variável",
          "manageVariables": "Gerenciar variáveis",
          "searchData": "Pesquisar dados",
          "title": "Preenchido pelo sistema",
          "toolTip": "Campos preenchidos pelo sistema",
          "variable": "Variável"
        }
      },
      "maxFileSizeLimitMessage": "The maximum file size supported is 20 MB",
      "multiLineLabel": "Permitir várias linhas",
      "name": "Nome",
      "noSignerComponentInfoModal": {
        "cancelButtonText": "Voltar",
        "confirmButtonText": "Continuar mesmo assim",
        "description": "Você pode continuar para a próxima etapa de qualquer maneira, ou você pode voltar e adicionar campos para que as pessoas preencham.",
        "subtitle": "Estas funções não têm nada para assinar:",
        "title": "Você se esqueceu de algum campo?"
      },
      "optionsLabel": "Opções",
      "paymentAmountInvalidError": "Insira um valor de pagamento para continuar",
      "personalFolders": "Pastas pessoais",
      "preparePage": {
        "footerButton": "Próxima etapa"
      },
      "previous": "Anterior",
      "radio": "Grupo de rádio",
      "readyState": "Pronto!",
      "reasonDeclineLabel": "Motivo da recusa",
      "reasonVoidLabel": "Razão nula",
      "recipientListHeading": "De que funções este modelo necessita?",
      "recipientName": "Nome",
      "recipientRemindButtonLabel": "Lembrar",
      "recipientRole": "Função",
      "recipientRoleSigner": "Signatário",
      "recipientRoleViewer": "Observador",
      "recipientStatusSigned": "Assinado",
      "recipientUniqueEmailErrorMessage": "O email do destinatário deve ser exclusivo.",
      "recipientUnlockLabel": "Desbloquear",
      "recipientsLabel": "Destinatários",
      "recordType": "Tipo de registro",
      "referenceIdLabel": "ID de referência",
      "reminderSent": "Lembrete enviado",
      "removeFieldLabel": "Remover campo",
      "requiredFieldLabel": "Campo obrigatório",
      "reviewAndSave": "Revisar e enviar",
      "reviewPage": {
        "descriptionPlaceholderText": "Insira o texto da descrição",
        "footerButton": "Salvar modelo",
        "kbaRequirement": "Requisito de KBA",
        "kbaTooltip": "Exija que os signatários verifiquem sua identidade com um questionário baseado em conhecimento. Cada signatário precisará verificar de forma independente antes de assinar o documento.",
        "passCodeTooltip": "Os destinatários devem inserir um código secreto de 5 dígitos para ter acesso aos documentos.",
        "passcodeLabel": "Código secreto",
        "securityOptionsLabel": "Opções de segurança",
        "templateNameBlank": "Insira um nome de modelo",
        "templatePlaceholderText": "Insira o nome de modelo"
      },
      "roleNameUniqueError": "O nome da função deve ser exclusivo",
      "roleNameValidationError": "O nome da função deve ser alfanumérico",
      "save": "Salvar",
      "selectOneOrMoreLabel": "Escolha um ou mais",
      "selectOnlyOneLabel": "Escolha apenas um",
      "selfSignature": "Sua assinatura",
      "sendAgreement": {
        "assignRequestBody": "Atribuir o usuário que assinou o contrato a todas as solicitações do cliente do compromisso",
        "assignRequestTitle": "Atribuir a solicitação ao usuário que assinou o contrato",
        "changeTemplate": "Alterar modelo",
        "document": "documento",
        "eSignaturePermissionErrorMessage": "Você não tem acesso a assinaturas. Entre em contato com seu administrador se precisar de acesso.",
        "nextTemplate": "Próximo: Selecionar modelo",
        "selectTemplateTitle": "Selecionar modelo",
        "selectedAgreementTemplate": "Modelo de contrato selecionado",
        "selectedClient": "Cliente selecionado",
        "shareRequestBody": "Compartilhar a solicitação atribuída",
        "shareRequestTitle": "Compartilhar a solicitação",
        "signatureDescription": "Quando o contrato for assinado e concluído",
        "stepsTitle": "Enviar etapas do fluxo de trabalho do contrato",
        "title": "Enviar contrato"
      },
      "setSigningOrder": "Definir ordem de assinatura",
      "setToDateOfExecution": "Definir a data de execução",
      "shareFileFolder": {
        "selectShareFileFolder": {
          "cancelButtonLabel": "Cancelar",
          "createFolderLabel": "Criar pasta",
          "disabledNodeAdminReason": "A permissão de administrador é necessária para escolher esta pasta",
          "disabledSharedFoldersReason": "Não é possível escolher pastas compartilhadas de nível superior",
          "modalTitle": "Local de armazenamento do documento assinado",
          "selectFolderButtonLabel": "Selecionar pasta"
        }
      },
      "sharedFolders": "Pastas compartilhadas",
      "signature": "Assinatura",
      "signatureAnnotationMessage": "Clique e arraste para traçar sua assinatura dentro da caixa",
      "signatureAnnotationTextMessage": "Digite sua assinatura no campo abaixo",
      "signatureRequest": {
        "closeDrawerModalContent": "Se você fechar essa solicitação agora, perderá seu progresso e terá que começar de novo",
        "closeDrawerModalTitle": "Descartar solicitação de assinatura"
      },
      "signatureRequestErrorMessage": "Falha na solicitação de assinatura",
      "signerDescription": "Você deve criar campos para cada função",
      "signers": "Signatários",
      "startPage": {
        "addAnotherRole": "Adicionar outra função",
        "addNewRole": "Adicionar uma nova função",
        "deleteButtonAriaLabel": "Excluir função {{roleName}}",
        "dragRoleAriaLabel": "Arrastar função {{roleName}}",
        "footerButton": "Próxima etapa: Colocar campos",
        "navigateAwayDialog": {
          "continue": "Continuar",
          "dontShowAgain": "Não mostrar esta mensagem novamente",
          "moveAwaySelections": "Se você sair da pasta atual, suas seleções serão perdidas."
        },
        "roleDescription": "Defina uma função para cada pessoa que assinará o documento. Sempre que alguém usar esse modelo, fornecerá um endereço de email para cada função",
        "roleLabel": "Funções do signatário",
        "roleName": "Nome da função",
        "sequenceInputAriaLabel": "Insira a sequência para a função {{roleName}}",
        "setSignerSequence": "Definir sequência de signatários"
      },
      "started_onboarding_agreement_flow": "Fluxo de contrato de integração iniciado",
      "templateCreationNotificationMessage": "Modelo {<templateName>} criado",
      "text": "Texto",
      "textAlignLabel": "Alinhar texto",
      "type": "Tipo",
      "unknown": "Desconhecido",
      "uploadDocumentErrorMessage": "Carregue um documento para passar para a próxima etapa",
      "uploadDocxFileModal": {
        "fileTypeErrorNotification": "Only DOCX files are supported",
        "okButtonText": "Create template",
        "title": "Upload DOCX file",
        "uploadTypes": {
          "computer": {
            "browse": "browse",
            "dragFilesHereOr": "Drag files here or"
          },
          "sharefile": "From ShareFile"
        }
      },
      "variableNameValidationError": "O nome da variável deve ser alfanumérico",
      "variables": {
        "addAnotherVariable": "Adicionar outra variável",
        "addNewVariable": "Adicionar nova variável",
        "dataSource": "Fonte de dados",
        "deleteButtonAriaLabel": "Excluir variável {{variableName}}",
        "description": "Use variáveis no seu modelo para que as informações possam ser preenchidas automaticamente. Você pode selecionar o tipo de dados e a fonte de dados. Ao utilizar o modelo, o remetente especificará os dados a serem coletados.",
        "errorMessages": {
          "invalidDataSource": "Precisamos de uma fonte de dados para cada variável",
          "invalidName": "Precisamos de um nome para cada variável",
          "invalidSourceRecord": "Precisamos de um registro de origem para cada variável",
          "uniqueName": "O nome da variável deve ser exclusivo"
        },
        "fieldsAssignedWarningHeader": "Campos atribuídos à variável",
        "fieldsAssignedWarningMessage": "Todos os campos atribuídos à variável serão removidos.",
        "label": "Variável",
        "missingDatasourceIntegration": {
          "addIntegrationBody": "Vá para: conta > Conexões > adicionar nova conexão.",
          "addIntegrationHeader": "Para adicionar uma nova integração",
          "message": "Sua conta não tem conexões de terceiros no momento.\n"
        },
        "sourceRecord": "Registro de origem",
        "variableName": "Nome da variável"
      },
      "zoomIn": "Mais zoom",
      "zoomOut": "Menos zoom"
    }
  }
];